const messages = {
  es: {
    translations: {

      signup: {
        title: "Registrarse",
        toasts: {
          success: "¡Usuario creado con éxito! ¡Inicia sesión!.",
          fail: "Error al crear el usuario. Comprueba los datos introducidos.",
          userCreationDisabled: "El registro de nuevos usuarios está deshabilitado.",
          verificationError: "Error al verificar permisos de registro.",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          company: "Nombre de la Organización",
          phone: "WhatsApp (Código de país + número)",
          phonePlaceholder: "+34 600 000 000",
          plan: "Plan",
          planDetails: {
            attendants: "Agentes",
            whatsapp: "WhatsApp",
            queues: "Colas",
            currency: "€",
          },
        },
        buttons: {
          submit: "Registrarse",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!"
        }
      },
      validation: {
        tooShort: "¡Muy corto!",
        tooLong: "¡Muy largo!",
        required: "Obligatorio",
        invalidEmail: "Correo electrónico inválido",
        emailPlaceholder: "Dirección de correo electrónico",
        phonePlaceholder: "Ej: +34 612 345 678 (opcional)",
      },
      schedulesForm: {
        keepFlowsOutOfHours: {
          title: "Mantener flujos activos fuera del horario",
          description: "Cuando está activo, los chatbots y flujos del FlowBuilder siguen respondiendo aunque sea fuera del horario de atención. El mensaje de ausencia abajo no se envía en este modo.",
        },
        outOfHoursMessage: {
          title: "Mensaje de ausencia",
          description: "Enviado automáticamente cuando un cliente escribe fuera del horario de atención.",
          placeholder: "Ej.: ¡Hola! Estamos fuera del horario de atención. Te responderemos pronto.",
        },
        helps: {
          keepFlowsOutOfHours: {
            description: "Controla lo que sucede cuando alguien escribe fuera del horario configurado abajo.",
            steps: [
              "Apagado (predeterminado): bots y flujos quedan pausados; el cliente recibe el mensaje de ausencia (si está configurado).",
              "Encendido: bots y FlowBuilder siguen funcionando normalmente; no se envía mensaje de ausencia.",
              "Active cuando sus flujos manejan 24/7 (autoservicio, FAQ, IA).",
              "Mantenga apagado si su flujo incluye agentes humanos que se desconectan.",
            ],
          },
          outOfHoursMessage: {
            description: "Texto enviado una vez por ticket cuando el cliente escribe fuera del horario.",
            steps: [
              "Active el toggle y escriba el mensaje que se enviará automáticamente.",
              "Se envía solo una vez por ticket — el cliente no recibe spam si manda varios mensajes.",
              "Funciona junto con el horario definido en \"General › Horario de Trabajo\".",
              "No se envía si \"Mantener flujos activos fuera del horario\" está encendido.",
            ],
          },
        },
        bulk: {
          fillWeekdays: "Días laborales 09:00–18:00",
          fillWeekdaysHelp: "Rellena lunes a viernes con 09:00–12:00 y 13:00–18:00",
          closeWeekend: "Fin de semana cerrado",
          closeWeekendHelp: "Vacía sábado y domingo",
          copyFirst: "Copiar del primer día",
          copyFirstHelp: "Aplica los horarios del lunes a los demás días",
          clearAll: "Borrar todo",
          clearAllHelp: "Elimina todos los horarios",
        },
        morning: "Mañana",
        afternoon: "Tarde",
        start: "Inicio",
        end: "Fin",
        dayClosed: "Cerrado este día",
      },
      login: {
        title: "Iniciar Sesión",
        logoAlt: "Logo",
        emailLabel: "Correo electrónico",
        passwordLabel: "Contraseña",
        rememberMe: "Recordarme",
        loginButton: "Iniciar Sesión",
        signupButton: "Regístrate",
        noAccount: "¿No tienes una cuenta?",
        forgotPassword: "¿Olvidaste la contraseña?",
        secureArea: "Área segura",
        emailPlaceholder: "tu@ejemplo.com",
        togglePassword: "Mostrar/ocultar contraseña",
        or: "o",
        whatsappLabel: "Chatea con nosotros en WhatsApp",
        whatsappTitle: "Chatea con nosotros en WhatsApp",
        form: {
          email: "Correo electrónico",
          password: "Contraseña",
          button: "Acceder"
        },
        buttons: {
          submit: "Iniciar Sesión",
          register: "¿No tienes una cuenta? ¡Regístrate!"
        }
      },
      companies: {
        title: "Empresas",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada con éxito!"
        }
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión realizado con éxito!"
        },
        dueDate: {
          expiration: "Tu suscripción vence en",
          days: "¡días!",
          day: "¡día!",
          expirationToday: "¡Tu suscripción vence hoy!"
        },
        token: "Token"
      },
      forgotPassword: {
        title: "Restablecer Contraseña",
        form: {
          emailLabel: "Ingresa tu correo electrónico",
          submitButton: "Enviar Enlace de Restablecimiento",
          backToLogin: "Volver al Inicio de Sesión",
        },
        loading: {
          sending: "Enviando...",
          sent: "¡Enviado!",
        },
        toasts: {
          success: "Enlace de restablecimiento de contraseña enviado con éxito",
        },
      },
      resetPassword: {
        title: "Restablecer Contraseña",
        form: {
          newPassword: "Nueva Contraseña",
          confirmPassword: "Confirmar Contraseña",
        },
        buttons: {
          submit: "Restablecer Contraseña",
          submitting: "Restableciendo...",
          submitted: "¡Restablecido!",
          backToLogin: "Volver al Inicio de Sesión",
        },
        errors: {
          passwordMismatch: "Las contraseñas no coinciden",
          passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
          invalidToken: "El token de restablecimiento está ausente o es inválido. Por favor, solicita un nuevo enlace de restablecimiento.",
          resetError: "Error al restablecer la contraseña. Inténtalo de nuevo.",
        },
        toasts: {
          success: "Contraseña restablecida con éxito",
          passwordMismatch: "Las contraseñas no coinciden",
          passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
        },
      },
      financeiro: {
        title: "Financiero",
        subtitle: "Sigue el estado de las empresas, planes y cobros en un solo lugar.",
        table: {
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Colas",
          value: "Valor mensual",
          dueDate: "Vencimiento",
          status: "Estado",
          action: "Acción",
          company: "Empresa",
          plan: "Plan"
        },
        stats: {
          total: "Empresas",
          totalHint: "Registradas en el sistema",
          revenue: "Ingreso activo",
          revenueHint: "Recurrencia mensual estimada",
          overdue: "Atrasadas",
          overdueHint: "Pagos pendientes",
          trial: "En prueba",
          trialHint: "Sin pago aún"
        },
        filters: {
          search: "Buscar por nombre o correo...",
          status: "Estado",
          all: "Todos los estados"
        },
        statusList: {
          active: "Al día",
          overdue: "Atrasada",
          trial: "Prueba",
          pending: "Pendiente",
          inactive: "Inactiva"
        },
        empty: {
          list: "Ninguna empresa registrada.",
          filtered: "Ninguna empresa encontrada con esos filtros."
        },
        tooltips: {
          details: "Detalles de la factura",
          users: "Número de usuarios",
          connections: "Número de conexiones",
          queues: "Número de colas",
          value: "Valor de la factura",
          dueDate: "Fecha de vencimiento"
        },
        status: {
          paid: "Pagado",
          overdue: "Vencido",
          open: "Abierto",
          yes: "Sí",
          no: "No",
          overdueFor: "Vencido hace {{days}} días",
          dueToday: "Vence hoy",
          dueIn: "Vence en {{days}} días"
        },
        buttons: {
          pay: "PAGAR",
          paid: "PAGADO",
          payNow: "PAGAR AHORA",
          charge: "Cobrar",
          chargeClient: "Cobrar cliente",
          inactive: "Inactiva"
        },
        charge: {
          title: "Cobrar cliente",
          phone: "Teléfono",
          email: "Correo",
          messageLabel: "Mensaje",
          whatsapp: "Enviar WhatsApp",
          emailBtn: "Enviar correo",
          emailSubject: "Pendiente financiero",
          openLink: "Abrir enlace de factura",
          copy: "Copiar mensaje",
          copied: "¡Mensaje copiado!",
          copyError: "No fue posible copiar.",
          noPhone: "Empresa sin teléfono registrado.",
          noEmail: "Empresa sin correo registrado.",
          noLink: "Factura sin enlace de pago."
        },
        checkout: {
          title: "¡Falta poco!",
          steps: {
            data: "Datos",
            customize: "Personalizar",
            review: "Revisar"
          },
          messages: {
            notFound: "No encontrado",
            paymentNotice: "¡Después de realizar el pago, actualiza la página!",
            subscriptionSuccess: "¡Suscripción realizada con éxito! Esperando el procesamiento del pago"
          },
          buttons: {
            back: "VOLVER",
            pay: "PAGAR",
            next: "SIGUIENTE"
          },
          pricing: {
            users: "Usuarios",
            connection: "Conexión",
            queues: "Colas",
            select: "SELECCIONAR",
            perMonth: "/mes"
          },
          review: {
            title: "Resumen de suscripción"
          },
          success: {
            total: "TOTAL",
            copied: "Copiado",
            copyQr: "Copiar código QR",
            finalizeMessage: "Para finalizar, simplemente realiza el pago escaneando o pegando el código Pix de arriba :)",
            licenseRenewed: "Tu licencia ha sido renovada hasta"
          },
          planDetails: {
            title: "Detalles del plan",
            billing: "Facturación: Mensual"
          },
          paymentInfo: {
            title: "Información de pago",
            email: "Email:",
            name: "Nombre:",
            document: "CPF/CNPJ:",
            total: "Total:"
          }
        }
      },
      dashboard: {
        title: "Panel de Control",
        subtitle: "Visión general de su atención en tiempo real",
        buttons: {
          filter: "Filtrar",
          export: "Exportar"
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Agentes",
          performance: "Rendimiento"
        },
        charts: {
          performance: "Gráficos",
          userPerformance: "Gráfico de Usuarios",
          hourlyServices: "Atendimientos por hora",
          ticketsLabel: "Tickets",
          score: "Puntuación",
          perDay: {
            title: "Atendimientos hoy: "
          },
          errorFetchingTickets: "Error al buscar información de los tickets",
          noDataAvailable: "No hay datos disponibles para el período seleccionado.",
          avgPerDay: "Media/día",
          peak: "Pico",
          totalAgents: "Agentes",
          topAgent: "Destacado",
          day: "día",
          days: "días",
          presets: {
            today: "Hoy",
            month: "Mes"
          },
        },
        cards: {
          inAttendance: "En Atención",
          waiting: "En Espera",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Mensajes Recibidos",
          totalSentMessages: "Mensajes Enviados",
          averageServiceTime: "T.M. de Atención",
          averageWaitingTime: "T.M. de Espera",
          status: "Estado (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos"
        },
        users: {
          name: "Nombre",
          numberAppointments: "Cantidad de Atendimientos",
          statusNow: "Actual",
          totalCallsUser: "Total de atenciones por usuario",
          totalAttendances: "Total de atenciones",
          totalLabel: "Total de atenciones: {{count}}",
          queues: "Colas",
          defaultQueue: "Conexión Predeterminada",
          workingHours: "Horario Laboral",
          startWork: "Inicio de Trabajo",
          endWork: "Fin de Trabajo",
          farewellMessage: "Mensaje de Despedida",
          theme: "Tema Predeterminado",
          menu: "Menú Predeterminado",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final"
        },
        licence: {
          available: "Disponible hasta"
        },
        assessments: {
          totalCalls: "Total de Atendimientos",
          callsWaitRating: "Atendimientos esperando evaluación",
          callsWithoutRating: "Atendimientos sin evaluación",
          ratedCalls: "Atendimientos evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntuación",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detractores",
          generalScore: "Puntuación NPS General",
        },
        status: {
          online: "Conectado",
          offline: "Desconectado",
        },
        filters: {
          title: "Filtros",
          initialDate: "Inicial",
          finalDate: "Final",
          filterButton: "Filtrar",
        },
        errors: {
          loadData: "No fue posible cargar los datos del dashboard.",
          exportExcel: "Error al exportar a Excel.",
        },
        export: {
          sheetName: "ReporteDeAgentes",
          fileName: "reporte-de-agentes.xlsx",
        },
        nps: {
          overallScore: "Puntuación NPS General",
        },
      },
      reports: {
        title: "Informes de Atendimientos",
        subtitle: "Historial completo de atenciones con filtros y exportación",
        kpis: {
          total: "Total de tickets",
          open: "Abiertos",
          closed: "Cerrados",
          rated: "Evaluados",
        },
        table: {
          id: "ID",
          whatsapp: "Conexión",
          contact: "Contacto",
          user: "Agente",
          queue: "Cola",
          status: "Estado",
          lastMessage: "Último mensaje",
          dateOpen: "Abierto en",
          dateClose: "Cerrado en",
          supportTime: "Tiempo de atención",
          NPS: "NPS",
          actions: "Acciones",
          empty: "No se encontraron atenciones para los filtros aplicados.",
        },
        buttons: {
          filter: "Filtrar",
          onlyRated: "Solo evaluados",
          export: "Exportar",
          clear: "Limpiar filtros",
        },
        filters: "Filtros",
        contactSearch: "Buscar contacto...",
        contactSearchHint: "Escribe al menos 2 letras",
        operator: "Operador",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Informes",
        calls: "Atendimientos",
        search: "Encuestas",
        durationCalls: "Duración de los Atendimientos",
        grupoSessions: "Atendimientos en Grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generando informe comprimido, por favor espere.",
          errorToast: "Error al generar el informe",
          back: "Volver",
          groupServiceReport: "Informe de Atendimientos en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha de Última Actualización",
          agent: "Quién Atendió",
          agentClosed: "Quién Cerró",
          waitingAssistance: "Esperando Atención",
          process: "En Atención"
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidad",
          percentage: "porcentaje",
          title: "Informe de Encuestas Realizadas",
          activeSearch: "Encuesta activa",
          inactiveSearch: "Encuesta inactiva"
        },
        ticketDurationDetail: {
          msgToast: "Generando informe comprimido, por favor espere.",
          title: "Informe de Duración del Atendimiento",
          startService: "Inicio del Atendimiento",
          lastUpdated: "Última Actualización",
          lastAgent: "Último Agente",
          durationFinished: "Duración después de finalizado"
        },
        ticketDuration: {
          title: "Informe de Duración de los Atendimientos",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones"
        },
        ticketReports: {
          msgToast: "Generando informe comprimido, por favor espere.",
          title: "Informe de Atendimientos"
        },
        pdf: {
          title: "Relación de Atendimientos Realizados",
          exportTitle: "Relación de Atendimientos en Grupos Realizados"
        },
        form: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        excel: {
          connection: "Conexión",
          contact: "Contacto",
          user: "Usuario",
          queue: "Cola",
          status: "Estado",
          lastMessage: "ÚltimoMensaje",
          dateOpen: "FechaApertura",
          timeOpen: "HoraApertura",
          dateClose: "FechaCierre",
          timeClose: "HoraCierre",
          supportTime: "TiempoDeAtención",
          nps: "nps",
          fileName: "informe-de-atenciones.xlsx",
          sheetName: "InformeDeAtenciones",
        },
        tooltips: {
          ticketLogs: "Logs del Ticket",
          accessTicket: "Acceder al Ticket",
          exportExcel: "Exportar a Excel",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        save: "Guardar",
        task: "Tareas"
      },
      contactImportWpModal: {
        modalTitle: "Exportar / Importar Contactos",
        title: "Exportar Contactos para el Excel",
        buttons: {
          downloadModel: "Descargar modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar Contactos"
        },
        form: {
          connection: "Conexión de WhatsApp",
          connectionPlaceholder: "Seleccionar conexión...",
          importType: "Tipo de importación",
          importAll: "Importar todos los contactos",
          importSelected: "Importar contactos seleccionados",
          overwriteExisting: "Sobrescribir contactos existentes"
        },
        validation: {
          connectionRequired: "Debes seleccionar una conexión",
          noContactsFound: "No se encontraron contactos para importar"
        },
        progress: {
          importing: "Importando contactos...",
          imported: "Contactos importados: {count}",
          duplicated: "Contactos duplicados: {count}",
          failed: "Contactos fallados: {count}"
        },
        importComplete: "Importación completada con éxito",
        importInProgress: "Importación en progreso {current} de {total} - no salga de esta pantalla hasta completar la importación",
        sheetName: "Contactos",
        columns: {
          name: "Nombre",
          number: "Número",
          email: "E-mail",
          tags: "Etiquetas",
          followUp: "Seguimiento",
          productName: "Producto (Nombre)",
          productStatus: "Producto (Estado)",
        },
        sampleContact: {
          name: "Juan",
          number: "5491112345678",
          email: "juan@email.com",
          tags: "cliente, vip",
          followUp: "",
          productName: "Curso Marketing",
          productStatus: "completado",
        },
      },
      tagsContainer: {
        tagTooShort: "¡Etiqueta muy corta!",
        title: "Etiquetas del Contacto",
        placeholder: "Agregar etiqueta...",
        add: "Agregar",
        remove: "Eliminar",
        noTags: "Sin etiquetas asignadas",
        createNew: "Crear nueva etiqueta",
        searchPlaceholder: "Buscar etiquetas...",
        buttons: {
          save: "Guardar Etiquetas",
          cancel: "Cancelar",
          clear: "Limpiar Todo"
        },
        validation: {
          tagRequired: "El nombre de la etiqueta es obligatorio",
          tagExists: "Esta etiqueta ya existe",
          maxTags: "Máximo {max} etiquetas permitidas"
        }
      },
      allConnections: {
        errors: {
          loadCompanies: "No fue posible cargar la lista de registros",
          unknownChannel: "error"
        },
        subtitle: "Conecte sus canales de atención para recibir mensajes e iniciar conversaciones con sus clientes.",
        channels: {
          whatsapp: "WhatsApp",
          facebook: "Facebook",
          instagram: "Instagram"
        },
        table: {
          client: "Cliente",
          connectedConnections: "Conexiones Conectadas",
          disconnectedConnections: "Conexiones Desconectadas",
          totalConnections: "Total de Conexiones",
          total: "Total"
        }
      },
      companyWhatsapps: {
        title: "Conexiones de: {{companyName}}",
        table: {
          channel: "Canal"
        }
      },
      channels: {
        whatsapp: "WhatsApp",
        whatsappOfficial: "WhatsApp API Oficial",
        facebook: "Facebook",
        instagram: "Instagram"
      },
      connections: {
        title: "Conexiones",
        subtitle: "Gestiona tus canales de atención (WhatsApp, Facebook, Instagram)",
        waitConnection: "Espera... ¡Tus conexiones se reiniciarán!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Llamar Soporte",
        toasts: {
          deleted: "¡Conexión eliminada con éxito!",
          officialApiSoon: "¡Integración con la API Oficial próximamente!",
          closedimported: "Estamos cerrando los tickets importados, por favor espere unos instantes"
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage: "Si confirmas, todos los tickets importados serán cerrados",
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "¿Estás seguro? Deberás leer el código QR de nuevo."
        },
        buttons: {
          add: "Agregar Conexión",
          disconnect: "Desconectar",
          tryAgain: "Intentar de nuevo",
          qrcode: "CÓDIGO QR",
          newQr: "Nuevo CÓDIGO QR",
          closedImported: "Cerrar todos los tickets importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes de WhatsApp",
          processed: "Procesado",
          in: "de",
          connecting: "Conectando",
          edit: "Editar",
          delete: "Eliminar"
        },
        empty: "Ninguna conexión registrada.",
        status: {
          connected: "Conectado",
          disconnected: "Desconectado",
          syncError: "Falla de sincronización",
          qrcode: "Código QR",
          pairing: "Emparejando",
          timeout: "Timeout",
          comingSoon: "Próximamente"
        },
        typography: {
          processed: "Procesado",
          in: "de",
          date: "Fecha del mensaje"
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar sesión de WhatsApp",
            content: "Asegúrate de que tu celular esté conectado a internet y intenta de nuevo, o solicita un nuevo Código QR"
          },
          qrcode: {
            title: "Esperando lectura del Código QR",
            content: "Haz clic en el botón 'CÓDIGO QR' y lee el Código QR con tu celular para iniciar la sesión"
          },
          connected: {
            title: "¡Conexión establecida!"
          },
          timeout: {
            title: "La conexión con el celular fue perdida",
            content: "Asegúrate de que tu celular esté conectado a internet y el WhatsApp esté abierto, o haz clic en el botón 'Desconectar' para obtener un nuevo Código QR"
          },
          syncError: {
            title: "Error al procesar mensajes",
            content: "La sesión está conectada, pero el sistema falló al guardar datos de la conexión. Reinicia la conexión y verifica nuevamente."
          }
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última actualización",
          "default": "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de WhatsApp",
          channel: "Canal"
        },
        iconChannel: {
          error: "Error"
        },
        facebook: {
          success: "Página conectada con éxito!",
        },
      },
      facebookModal: {
        title: "Conectar {{channel}}",
        description: "Siga los pasos a continuación para conectar {{channel}} al sistema de atención.",
        steps: {
          step1: {
            title: "Tener una App configurada en Meta for Developers",
            description: "Necesita tener una aplicación creada en Meta for Developers con los productos Messenger e Instagram configurados.",
          },
          step2: {
            title: "Tener una Página de Facebook",
            description: "Necesita ser administrador de una Página de Facebook. Messenger se conectará a esta página.",
          },
          step3instagram: {
            title: "Cuenta Instagram Business vinculada a la Página",
            description: "Para recibir mensajes de Instagram, su cuenta de Instagram debe ser del tipo Business o Profesional y estar vinculada a su Página de Facebook.",
          },
          stepConnect: {
            title: "Autorizar la conexión",
            description: "Haga clic en el botón de abajo para iniciar sesión con su cuenta de Facebook y autorizar {{channel}} para recibir y enviar mensajes a través del sistema.",
          },
        },
        permissions: {
          title: "Permisos solicitados:",
          sendReceive: "Enviar y recibir mensajes a través de la página",
          pagesList: "Listar sus páginas de Facebook",
          managePages: "Administrar metadata de las páginas",
          instagramMessages: "Enviar y recibir mensajes de Instagram Direct",
        },
        warning: {
          title: "Importante:",
          facebook: "Después de la autorización, todas las páginas vinculadas a su cuenta se conectarán automáticamente.",
          instagram: "Su cuenta de Instagram debe ser Business/Profesional y estar vinculada a una Página de Facebook. Después de la autorización, Instagram se conectará automáticamente.",
        },
        buttons: {
          cancel: "Cancelar",
          connect: "Conectar {{channel}}",
          connecting: "Conectando...",
        },
        errors: {
          noAppIdTitle: "Configuración pendiente!",
          noAppId: "Para conectar Facebook/Instagram es necesario configurar el App ID de Meta. Acceda a Meta for Developers, cree un App y configure la variable REACT_APP_FACEBOOK_APP_ID en el sistema.",
        },
        success: {
          facebook: "Facebook Messenger conectado con éxito!",
          instagram: "Instagram Direct conectado con éxito!",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimiento Existente"
        },
        form: {
          message: "Este contacto ya está en atención:",
          user: "Agente",
          queue: "Cola",
          messageWait: "Este contacto ya está esperando atención. ¡Ve en la pestaña Esperando!",
          ticketId: "ID del Ticket",
          status: "Estado",
          createdAt: "Creado en",
          updatedAt: "Actualizado en"
        },
        buttons: {
          goToTicket: "Ir al Ticket",
          close: "Cerrar",
          transferTicket: "Transferir Ticket"
        },
        status: {
          open: "Abierto",
          pending: "Pendiente",
          closed: "Cerrado"
        }
      },
      showTicketLogModal: {
        title: {
          header: "Historial del ticket"
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Cola definida.",
          open: " inició la atención.",
          access: "accedió al ticket.",
          transfered: "transfirió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "devolvió a la cola.",
          closed: "cerró el ticket.",
          reopen: "reabrió el ticket.",
          redirect: " - redirigido."
        },
        close: "Cerrar",
        empty: "Aún no hay registros para este ticket.",
      },
      statusFilter: {
        title: "Filtro por Estado",
        groups: "Grupos",
        selected: "seleccionados",
      },
      whatsappModal: {
        title: {
          add: "Agregar Conexión",
          edit: "Editar Conexión"
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "NPS",
          integrations: "Integraciones",
          schedules: "Horario de atención",
          chatbot: "Chatbot",
          defaultFlow: "Flujo por Defecto"
        },
        form: {
          identitySectionTitle: "Identificación",
          behaviorSectionTitle: "Comportamiento",
          tokenRefreshTooltip: "Generar nuevo token",
          tokenCopyTooltip: "Copiar token",
          queueIdImportMessagesDesc: "Cola a la que serán dirigidos los tickets creados por la importación. Define una cola específica para aislar el historial importado de los tickets activos.",
          sendIdQueueDesc: "Cola por defecto para recibir tickets de contactos que aún no están asignados a ninguna cola. Funciona como fallback automático.",
          timeSendQueueDesc: "Tiempo (en minutos) que el sistema espera antes de mover el contacto sin cola a la cola por defecto. Usa 0 para desactivar el redireccionamiento automático.",
          queuesSectionTitle: "Colas de atención",
          queuesSectionDesc: "Colas (departamentos) que recibirán los tickets de esta conexión. Los agentes miembros de estas colas tendrán acceso a los tickets.",
          queuesHelp: "Selecciona una o más colas. Cada mensaje que entre por esta conexión estará disponible para los agentes asociados a estas colas. Si no se selecciona ninguna cola, solo los administradores verán los tickets.",
          integrationSectionTitle: "Integración externa",
          integrationSectionDesc: "Reenvía los mensajes de esta conexión a un sistema externo (Typebot, Dialogflow, n8n, webhook personalizado, etc.) en lugar de colas internas.",
          integrationHelp: "Cuando se selecciona una integración, los mensajes son procesados por el sistema externo configurado en Configuración > Integraciones. Útil para automatizaciones con IA o bots personalizados. Nota: elegir una integración limpia las colas (son mutuamente excluyentes).",
          integrationsInfoTitle: "ⓘ Cómo funcionan Colas e Integraciones",
          integrationsInfoText: "Cada conexión puede enrutar los mensajes recibidos de dos formas:<ul><li><strong>Colas:</strong> distribuye los tickets entre agentes humanos organizados en departamentos.</li><li><strong>Integración externa:</strong> envía los mensajes a un sistema automatizado (bot, IA, webhook).</li></ul><strong>Importante:</strong> las dos opciones son mutuamente excluyentes — elegir una limpia automáticamente la otra.",
          npsInfoTitle: "ⓘ Qué es el NPS y cómo funciona aquí",
          npsInfoText: "<strong>NPS (Net Promoter Score)</strong> es una encuesta enviada al cliente <strong>después de cerrar el ticket</strong>, pidiendo una nota de <strong>0 a 10</strong> sobre la experiencia.<ul><li>La pregunta se envía automáticamente por el bot del sistema.</li><li>La nota recibida queda almacenada y puede consultarse en los informes.</li><li>Si el cliente no responde, el sistema reenvía hasta el máximo configurado.</li><li>Tras el tiempo límite, el ticket de evaluación se cierra automáticamente.</li></ul><strong>Importante:</strong> para activar el envío de NPS hay que habilitar <em>Evaluación de usuario</em> en Configuración → Empresa.",
          npsSurveySectionTitle: "Encuesta de evaluación",
          npsRulesSectionTitle: "Reglas de envío",
          ratingMessageDesc: "Texto enviado al cliente solicitando la nota. Usa una frase corta y amable. La escala obligatoria es de 0 a 10. Ej: 'De 0 a 10, ¿qué tan probable es que recomiendes nuestro servicio?'",
          maxUseBotQueuesNPSDesc: "Número máximo de veces que la pregunta de evaluación será reenviada si el cliente no responde. Recomendado: 2 o 3 intentos.",
          expiresTicketNPSDesc: "Tiempo (en minutos) que el sistema espera una respuesta antes de cerrar automáticamente el ticket de evaluación. Usa 0 para no cerrar automáticamente.",
          imageLabel: "Imagen de la conexión",
          imageDesc: "Foto/video opcional para identificar visualmente esta conexión en tu lista de canales.",
          nameDesc: "Nombre interno de la conexión (visible solo para tu equipo). Usa algo descriptivo como 'Soporte Comercial' o 'Ventas BR'.",
          defaultDesc: "Cuando está activada, esta es la conexión utilizada por defecto para envíos automáticos (campañas, integraciones, API externa).",
          groupDesc: "Permite que los mensajes de grupos de WhatsApp sean recibidos y abran tickets en la plataforma. Desactivado por defecto para evitar ruido.",
          groupAsTicketDesc: "Define cómo se manejan los mensajes de grupo: 'Habilitado' crea un ticket por grupo; 'Deshabilitado' los ignora o agrupa.",
          importSectionTitle: "Importación de mensajes",
          importSectionDesc: "Recupera el historial reciente de conversaciones del dispositivo conectado. Configura con cuidado: la importación es limitada y puede afectar el rendimiento.",
          importInfoTitle: "ⓘ Antes de activar, lee con atención",
          importInfoText: "La importación <strong>no trae todo el historial</strong> de WhatsApp — solo los mensajes que aún están en caché en el dispositivo.<ul><li><strong>Límite real:</strong> normalmente solo las últimas semanas/meses son recuperables, según el uso del aparato.</li><li><strong>La conexión se cerrará</strong> al guardar y deberás leer el Código QR de nuevo.</li><li><strong>Puede tardar bastante</strong> y generar carga en el servidor mientras se ejecuta.</li><li><strong>Recomendación:</strong> para empezar limpio, prefiere <strong>crear una nueva conexión</strong> sin importación y deja que el historial se construya de forma natural.</li></ul>",
          importOldMessagesEnable: "Importar mensajes del dispositivo",
          importOldMessagesEnableDesc: "Activa el intento de importar las conversaciones en caché del móvil al conectar. Úsalo solo si realmente necesitas historial anterior.",
          importOldMessages: "Fecha de inicio de la importación",
          importRecentMessages: "Fecha de finalización de la importación",
          importOldMessagesGroups: "Importar mensajes de grupo",
          importOldMessagesGroupsDesc: "Incluye el historial de conversaciones de grupos en el alcance de la importación. Puede aumentar mucho el volumen de tickets generados.",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          closedTicketsPostImportedDesc: "Marca automáticamente como cerrados todos los tickets creados por la importación. Útil para no saturar la cola de los agentes.",
          name: "Nombre",
          tokenSectionTitle: "Token para integración externa",
          tokenSectionDesc: "Usa este token para autenticar peticiones a la API del sistema usando esta conexión como remitente. Mantenlo en secreto.",
          queueRedirection: "Redirección de Cola",
          queueRedirectionDesc: "Define a qué cola los contactos sin cola asignada serán redirigidos automáticamente después del tiempo configurado.",
          "default": "Predeterminado",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redirigir a la cola",
          importAlert: "ATENCIÓN: al guardar, la conexión se cerrará y deberás leer el Código QR de nuevo. La importación solo trae lo que esté en caché en el dispositivo — no es el historial completo de WhatsApp.",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Crear nuevo ticket en x minutos",
          maxUseBotQueues: "Enviar bot x veces",
          timeUseBotQueues: "Enviar bot en x minutos",
          expiresTicket: "Cerrar chats abiertos después de x minutos",
          expiresTicketNPS: "Cerrar chats esperando evaluación después de x minutos",
          maxUseBotQueuesNPS: "Cantidad máxima de veces que la evaluación va a ser enviada",
          closeLastMessageOptions1: "Del agente/Cliente",
          closeLastMessageOptions2: "Del agente",
          outOfHoursMessage: "Mensaje de fuera de horario de atención",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para política de privacidad",
          lgpdMessage: "Mensaje de bienvenida LGPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrado por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - La escala debe ser de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Cola",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage: "Tiempo en minutos para envío del aviso de inactividad",
          whenExpiresTicket: "Cerrar chats abiertos cuando la última mensaje sea",
          expiresInactiveMessage: "Mensaje de cierre por inactividad",
          prompt: "Prompt",
          collectiveVacationEnd: "Fecha final",
          collectiveVacationStart: "Fecha inicial",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          queueIdImportMessages: "Cola para importar los mensajes"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Deshabilitado",
          minutes: "minutos"
        },
        messages: {
          clickSaveToRegister: "Haga clic en guardar para registrar cambios",
        },
        flowBuilder: {
          welcomeFlow: "Flujo de bienvenida",
          welcomeFlowLabel: "Selecciona un flujo de bienvenida",
          welcomeFlowDescription: "Se dispara cuando un contacto totalmente nuevo (que no existe aún en tu base) envía el primer mensaje a esta conexión.",
          welcomeFlowHelp: "Úsalo para presentar la empresa, pedir el nombre, recopilar datos iniciales o redirigir al cliente automáticamente a una cola. El flujo debe estar creado en FlowBuilder antes de aparecer aquí. Deja 'Deshabilitado' si prefieres que los nuevos contactos caigan directamente en la cola por defecto.",
          defaultResponseFlow: "Flujo de respuesta por defecto",
          defaultResponseFlowLabel: "Selecciona un flujo de respuesta por defecto",
          defaultResponseFlowDescription: "Se dispara para cualquier mensaje que NO coincida con una palabra clave configurada. Atención: también se dispara cuando la atención lleva más de 6 horas cerrada.",
          defaultResponseFlowHelp: "Úsalo para responder automáticamente cuando el cliente escribe algo inesperado o después de mucha inactividad. Cuidado: si está mal configurado puede confundir al cliente en conversaciones activas. Se recomienda un flujo corto que solo invite a contactar en horario comercial. Deja 'Deshabilitado' para silenciar las respuestas automáticas.",
          infoTitle: "ⓘ Qué es el Flujo Por Defecto",
          infoText: "Permite vincular esta conexión a flujos automatizados creados en <strong>FlowBuilder</strong>. Hay dos disparadores:<ul><li><strong>Flujo de bienvenida:</strong> se ejecuta en el primer mensaje de un contacto nuevo.</li><li><strong>Flujo de respuesta por defecto:</strong> se ejecuta cuando un mensaje no coincide con ninguna palabra clave o cuando la atención lleva más de 6 horas cerrada.</li></ul><strong>Para configurar:</strong> primero crea el flujo en <em>FlowBuilder</em> en el menú lateral, luego selecciónalo aquí. Los flujos solo se ejecutan cuando esta conexión está en línea.",
          title: "Flujo por defecto",
          save: "Guardar",
          updatedSuccess: "Flujos por defecto actualizados",
          deleteConfirmation: "¿Estás seguro de que deseas eliminar este flujo? Todas las integraciones relacionadas se perderán.",
        },
        success: "Conexión guardada con éxito.",
        errorSendQueue: "Se informó tiempo para redirigir cola, pero no se seleccionó cola para redirigir. Ambos campos deben estar llenos",
        errorExpiresNPS: "Es obligatorio informar un tiempo para evaluación cuando se utiliza el NPS.",
        errorRatingMessage: "Es obligatorio informar un mensaje de evaluación cuando se utiliza el NPS."
      },
      qrCode: {
        message: "Lee el QrCode para iniciar la sesión"
      },
      qrcodeModal: {
        title: "Conectar WhatsApp",
        intro: "Usa WhatsApp en tu teléfono para escanear el código a la derecha y conectar esta sesión. El proceso toma solo unos segundos.",
        step1: "Abre <strong>WhatsApp</strong> en tu teléfono.",
        step2: "Toca <strong>Más opciones</strong> (Android) o <strong>Ajustes</strong> (iPhone).",
        step3: "Selecciona <strong>Dispositivos vinculados</strong> y luego <strong>Vincular un dispositivo</strong>.",
        step4: "Apunta la cámara del teléfono al Código QR a la derecha.",
        statusReady: "Listo para escanear",
        waiting: "Esperando el Código QR..."
      },
      forbiddenPage: {
        accessDenied: "¡Ups! ¡Acceso Denegado!",
        buttons: {
          back: "Volver"
        }
      },
      contacts: {
        title: "Contactos",
        subtitleCount: "contactos",
        toasts: {
          deleted: "¡Contacto eliminado con éxito!"
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar ",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage: "¿Estás seguro de que deseas eliminar este contacto? Todas las atenciones relacionadas se perderán.",
          blockContact: "¿Estás seguro de que deseas bloquear este contacto?",
          unblockContact: "¿Estás seguro de que deseas desbloquear este contacto?",
          importMessage: "¿Desea importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport: "¿Desea importar todas las conversaciones del teléfono?"
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
          edit: "Editar",
          block: "Bloquear",
          unblock: "Desbloquear",
          delete: "Eliminar",
          startChat: "Iniciar conversación"
        },
        status: {
          active: "Activo",
          inactive: "Inactivo"
        },
        phantomCleanup: {
          button: "Limpiar fantasmas",
          help: "¿Por qué ocurre?",
          confirmTitle: "Limpiar contactos fantasmas",
          confirmMessage: "Se encontraron {{count}} contactos fantasmas. Serán eliminados permanentemente de la base. ¿Deseas continuar?",
          noneFound: "No se encontraron contactos fantasmas en tu base. ¡Todo limpio!",
          deletedSuccess: "contactos fantasmas eliminados",
          helpTitle: "¿Por qué aparecen contactos fantasmas?",
          helpIntro: "Los contactos fantasmas son entradas con números inválidos, sin nombre, o creados automáticamente por el sistema sin corresponder a un contacto real de WhatsApp.",
          helpWhy: "¿Por qué ocurre?",
          helpReason1: "Es una limitación de la biblioteca Baileys (que conecta con WhatsApp Web). Cuando WhatsApp envía eventos de sincronización — broadcasts, listas, estados — la biblioteca puede interpretar esos identificadores como contactos nuevos, aunque no representen personas reales.",
          helpReason2: "Resultado: aparecen entradas con números muy cortos, con prefijos extraños (555000…, 120363…), o sin dígitos suficientes para ser un teléfono válido.",
          helpFixTitle: "¿Qué hace esta limpieza?",
          helpFixBody: "Identifica contactos con número inválido (fuera del formato E.164, secuencias repetidas, prefijos sospechosos) o creados automáticamente fuera de la agenda, y los elimina permanentemente. Los contactos legítimos no se ven afectados.",
          helpClose: "Entendido"
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo electrónico",
          connection: "Conexión",
          actions: "Acciones",
          lastMessage: "Última Mensaje",
          status: "Estado",
          source: "Origen",
          followUp: "Seguimiento",
          tags: "Etiquetas",
          products: "Producto",
          payment: "Pago",
          attendant: "Agente",
          selectAll: "Seleccionar todos los contactos",
          selectContact: "Seleccionar contacto {{name}}",
        },
        productStatus: {
          pending: "Pendiente",
          completed: "Completado",
          cancelled: "Cancelado",
          refunded: "Reembolsado",
          in_progress: "En Progreso",
        },
        menu: {
          importYourPhone: "Importar del dispositivo predeterminado",
          importToExcel: "Importar / Exportar del Excel",
          importExport: "Importar / Exportar"
        },
        bulkActions: {
          deleteSelected: "Eliminar Seleccionados ({{count}})",
          deleteConfirmTitle: "¿Estás seguro de que deseas eliminar {{count}} contactos seleccionados?",
          deleteConfirmMessage: "Esta acción es irreversible.",
          deleteSuccess: "¡Contactos seleccionados eliminados con éxito!",
          blockContact: "Contacto bloqueado",
          unblockContact: "Contacto desbloqueado",
          selectConnectionToImport: "Elige de qué conexión deseas importar"
        },
        tagsFilter: {
          title: "Filtrar por Etiquetas",
          placeholder: "Selecciona etiquetas...",
          noTags: "Sin etiquetas disponibles",
          clearFilters: "Limpiar filtros",
          selectedTags: "Etiquetas seleccionadas"
        },
        validation: {
          nameRequired: "El nombre es obligatorio",
          numberRequired: "El número es obligatorio",
          emailRequired: "El email es obligatorio",
          invalidEmail: "Email inválido",
          numberExists: "Este número ya existe",
          emailExists: "Este email ya existe",
          invalidNumber: "Número inválido",
          numberTooShort: "Número demasiado corto",
          numberTooLong: "Número demasiado largo",
          nameTooShort: "Nombre demasiado corto",
          nameTooLong: "Nombre demasiado largo"
        },
        filters: {
          title: "Filtros",
          any: "Cualquiera",
          clearAll: "Limpiar filtros",
          apply: "Aplicar",
          tagsLabel: "Etiquetas",
          showLabel: "Mostrar",
          showOnlyAgenda: "Solo mi agenda",
          showAll: "Todos los contactos",
          source: "Origen",
          sourceAll: "Todos",
          sourceManual: "Manual",
          sourceWhatsappRoster: "WhatsApp (agenda)",
          sourceExcelImport: "Excel/CSV",
          sourceAutoCreated: "Auto-creados",
          sourceChatImport: "Chats"
        },
        source: {
          manual: "Creado manualmente",
          whatsappRoster: "Importado de WhatsApp",
          excelImport: "Importado de Excel/CSV",
          autoCreated: "Auto-creado por mensaje",
          chatImport: "Importado de chats"
        },
      },
      tagsFilter: {
        placeholder: "Filtrar por Etiquetas",
      },
      contactImport: {
        title: "Importar contactos desde archivo",
        subtitle: "Envía un archivo XLS, XLSX, CSV o TXT para importar contactos en lote",
        validation: {
          noNumberField: "No se seleccionó el campo de número de contacto",
          noNameField: "No se seleccionó el campo de nombre de contacto",
          noContactsSelected: "Ningún contacto seleccionado",
          fieldAlreadySelected: "El campo {{field}} ya fue seleccionado."
        },
        messages: {
          successComplete: "Importación realizada con éxito",
          successWithErrors: "Importación realizada con éxito, pero hubo algunos errores",
          importing: "Importando... Espere",
          processing: "Procesando archivo...",
          invalidFile: "¡Archivo inválido!",
          contactsCreated: "contactos creados",
          contactsIgnored: "contactos ignorados (número inválido o no marcados para actualizar)"
        },
        fields: {
          name: "Nombre",
          number: "Número",
          email: "E-mail",
          tags: "Etiquetas",
          followUp: "Seguimiento (Observaciones)",
          productName: "Producto (Nombre)",
          productStatus: "Producto (Estado)"
        },
        buttons: {
          downloadModel: "Descargar modelo",
          validateWhatsApp: "Validar contactos en WhatsApp",
          importContacts: "Importar contactos",
          cancel: "Cancelar",
          back: "Volver"
        },
        dropzone: {
          clickOrDrag: "Haga clic o arrastre un archivo",
          importantNote: "* Importante: Solo se aceptan archivos con extensiones: xls, xlsx, csv, txt"
        },
        sheetName: "Contactos",
        sampleContact: {
          name: "Juan",
          number: "5491112345678",
          email: "juan@email.com",
          tags: "cliente, vip",
          followUp: "",
          productName: "Curso Marketing",
          productStatus: "completado"
        },
        filters: {
          filter: "Filtrar",
          clearAll: "Limpiar filtros",
          noResults: "No se encontraron resultados"
        }
      },
      forwardMessage: {
        text: "Reenviada"
      },
      forwardMessageModal: {
        title: "Reenviar mensajes a",
        searchPlaceholder: "Buscar nombre o número",
        recentConversations: "Conversaciones recientes",
        createContact: "Crear contacto \"{{name}}\"",
        typeToSearch: "Escribe para buscar contactos.",
        selectedMessage: "{{count}} mensaje seleccionado",
        selectedMessages: "{{count}} mensajes seleccionados",
        selectedRecipient: "{{count}} destinatario seleccionado",
        selectedRecipients: "{{count}} destinatarios seleccionados",
        sending: "Enviando {{target}}...",
        buttons: {
          ok: "Reenviar"
        }
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes en el Historial",
          voiceKey: "Clave de la API de Voz",
          voiceRegion: "Región de Voz",
          model: "Modelo"
        },
        success: "¡Prompt guardado con éxito!",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          required: "Obligatorio",
          promptDescription: "Describe el entrenamiento para Inteligencia Artificial",
          invalidModel: "Modelo inválido",
          informModel: "Informa el modelo",
          minTokens: "Mínimo 10 tokens",
          maxTokens: "Máximo 4096 tokens",
          informMaxTokens: "Informa el número máximo de tokens",
          minZero: "Mínimo 0",
          maxOne: "Máximo 1",
          informTemperature: "Informa la temperatura",
          informApiKey: "Informa la API Key",
          informQueue: "Informa la cola",
          minMessages: "Mínimo 1 mensaje",
          maxMessages: "Máximo 50 mensajes",
          informMaxMessages: "Informa el número máximo de mensajes",
          informVoiceMode: "Informa el modo de voz"
        },
        errors: {
          savePrompt: "Error al guardar el prompt"
        },
        models: {
          "gpt-4.1": "GPT 4.1",
          "gpt-4.1-mini": "GPT 4.1 Mini",
          "gpt-4.1-nano": "GPT 4.1 Nano",
          "gpt-4o": "GPT 4o",
          "gpt-4o-mini": "GPT 4o Mini",
          "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legado)",
          "gemini-2.5-pro": "Gemini 2.5 Pro",
          "gemini-2.5-flash": "Gemini 2.5 Flash",
          "gemini-2.0-flash": "Gemini 2.0 Flash",
          "gemini-2.0-pro": "Gemini 2.0 Pro",
        },
        voices: {
          text: "Texto",
          francisca: "Francisca",
          antonio: "Antonio",
          brenda: "Brenda",
          donato: "Donato",
          elza: "Elza",
          fabio: "Fabio",
          giovanna: "Giovanna",
          humberto: "Humberto",
          julio: "Julio",
          leila: "Leila",
          leticia: "Leticia",
          manuela: "Manuela",
          nicolau: "Nicolau",
          valerio: "Valerio",
          yara: "Yara"
        }
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Cola",
          max_tokens: "Máximo Tokens Respuesta",
          actions: "Acciones"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!"
        },
        buttons: {
          add: "Agregar Prompt"
        },
        errors: {
          noPermission: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo."
        }
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
          createCard: "Crear tarjeta"
        },
        form: {
          kanbanLane: "Columna del Kanban",
          kanbanLaneHelp: "Selecciona en qué columna se creará la tarjeta.",
          mainInfo: "Datos del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de WhatsApp",
          optional: "opcional",
          email: "Correo electrónico",
          extraName: "Nombre del campo",
          extraValue: "Descripción",
          chatBotContact: "Deshabilitar chatbot",
          followUp: "Seguimiento (Observaciones)",
          followUpPlaceholder: "Observaciones sobre el contacto...",
          termsLGDP: "Términos LGPD aceptados en:",
          whatsapp: "Conexión Origen: ",
          numberPlaceholder: "5513912344321",
          emailPlaceholder: "Dirección de correo electrónico",
          products: "Productos",
          productName: "Nombre del producto",
          tags: "Etiquetas",
          tagsPlaceholder: "Seleccionar o crear etiquetas",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          addProduct: "Agregar",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Contacto guardado con éxito."
      },
      contactTagListModal: {
        title: "Contactos",
        table: {
          id: "ID",
          name: "Nombre",
          number: "Número",
          actions: "Acciones"
        }
      },
      flowbuilder: {
        title: "Flujos de conversación",
        subtitle: "Gestiona flujos de conversación y automatizaciones de atención",
        subMenus: {
          campaign: "Flujo de Campaña",
          conversation: "Flujo de Conversación"
        },
        buttons: {
          add: "Agregar Flujo",
          editName: "Editar nombre",
          editFlow: "Editar flujo",
          duplicate: "Duplicar",
          delete: "Eliminar"
        },
        table: {
          status: "Estado"
        },
        status: {
          active: "Activo",
          inactive: "Inactivo"
        },
        toasts: {
          deleteSuccess: "Flujo eliminado con éxito",
          duplicateSuccess: "Flujo duplicado con éxito"
        },
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que quieres eliminar este flujo? Se perderán todas las integraciones relacionadas.",
          duplicateTitle: "¿Quieres duplicar el flujo {flowName}?",
          duplicateMessage: "¿Estás seguro de que quieres duplicar este flujo?"
        }
      },
      knowledgeBase: {
        title: "Base de Conocimiento",
        tabs: {
          rag: "Base de Conocimiento (RAG)",
          qualification: "Calificación del Agente",
        },
        rag: {
          title: "Base de Conocimiento",
          subtitle: "Fuentes y contenidos usados por el agente para responder con RAG",
          actions: {
            refresh: "Actualizar",
            newBase: "Nueva Base RAG",
            createFirst: "Crear primera base",
            createBase: "Crear Base",
            cancel: "Cancelar",
            processing: "Procesando...",
            indexKnowledge: "Indexar contenido",
          },
          stats: {
            created: "Bases creadas",
            indexed: "Bases indexadas",
            totalChunks: "Fragmentos totales",
          },
          empty: {
            title: "Ninguna base de conocimiento creada",
            description: "Crea una base y sube documentos (PDF, TXT, CSV) o pega texto. El agente de IA usará esta información para responder a tus clientes.",
          },
          table: {
            name: "Nombre",
            type: "Tipo",
            file: "Archivo",
            createdAt: "Creado el",
            actions: "Acciones",
          },
          status: {
            pending: "Pendiente",
            processing: "Procesando",
            indexed: "Indexado",
            error: "Error",
            active: "Activo",
            importing: "Importando",
          },
          sourceTypes: {
            text: "Texto",
            pdf: "PDF",
            csv: "CSV",
            url: "URL",
          },
          tooltips: {
            index: "Indexar contenido",
            delete: "Eliminar",
          },
          dialogs: {
            newBaseTitle: "Nueva Base de Conocimiento",
            indexTitle: "Indexar contenido - {{name}}",
            indexDescription: "Elige cómo deseas agregar contenido. Se dividirá en fragmentos y se preparará para la búsqueda semántica del agente de IA.",
            processingDescription: "Procesando contenido... Esto puede tardar algunos minutos.",
          },
          form: {
            name: "Nombre",
            namePlaceholder: "Ej.: Catálogo de Productos, FAQ, Políticas...",
            description: "Descripción",
            descriptionPlaceholder: "Describe el contenido de esta base...",
            sourceType: "Tipo de Fuente",
            chunkSize: "Tamaño del fragmento",
            recommended512: "Recomendado: 512",
            recommended50: "Recomendado: 50",
            apiKeyLabel: "Clave API (OpenAI)",
            apiKeyHelp: "Necesaria para generar vectores de búsqueda",
            filePlaceholder: "Haz clic para seleccionar archivo (PDF, TXT, CSV...)",
            content: "Contenido",
            contentPlaceholder: "Pega aquí el texto...",
            siteUrl: "URL del sitio",
            siteUrlHelp: "Ingresa la URL completa",
          },
          ingestModes: {
            file: "Archivo",
            text: "Texto",
            url: "URL / Sitio",
          },
          toasts: {
            created: "Base creada con éxito!",
            deleted: "Base eliminada!",
            fillContent: "Completa el contenido, selecciona un archivo o ingresa una URL.",
            indexed: "Contenido indexado con éxito!",
          },
          confirm: {
            deleteBase: "¿Seguro que deseas eliminar esta base de conocimiento?",
          },
        },
        datasets: {
          titles: {
            catalogs: "Catálogos",
            qualification: "Calificación del Agente",
          },
          subtitles: {
            catalogs: "Datos estructurados para consultar productos, precios y disponibilidad",
            qualification: "Campos y datasets que el agente debe completar durante la atención",
          },
          dialogs: {
            newCatalogTitle: "Nuevo Catálogo",
            newQualificationTitle: "Nueva Calificación",
            importTitle: "Importar Datos - {{name}}",
            processingImport: "Procesando importación...",
          },
          form: {
            name: "Nombre",
            catalogName: "Nombre del catálogo",
            description: "Descripción (opcional)",
            fieldName: "Nombre del campo",
            type: "Tipo",
          },
          actions: {
            addField: "Agregar campo",
            refresh: "Actualizar",
            newCatalog: "Nuevo Catálogo",
            newQualification: "Nueva Calificación",
            createCatalog: "Crear Catálogo",
            createQualification: "Crear Calificación",
            createFirstCatalog: "Crear primer catálogo",
            createFirstQualification: "Crear primera calificación",
            importData: "Importar Datos",
            cancel: "Cancelar",
          },
          stats: {
            datasets: "Datasets",
            totalRows: "Filas totales",
          },
          empty: {
            catalogTitle: "Ningún catálogo creado",
            qualificationTitle: "Ninguna calificación creada",
            catalogDescription: "Crea un catálogo e importa datos (CSV, Google Sheets). El agente de IA usará estos datos para consultar productos, precios y disponibilidad.",
            qualificationDescription: "Crea los campos que el agente de IA debe completar durante la atención (ej.: nombre, interés, temperatura del lead).",
          },
          table: {
            name: "Nombre",
            source: "Fuente",
            columns: "Columnas",
            rows: "Filas",
            createdAt: "Creado el",
            type: "Tipo",
            mode: "Modo",
            actions: "Acciones",
          },
          tooltips: {
            viewData: "Ver datos",
            importData: "Importar datos",
            delete: "Eliminar",
            resyncGoogleSheets: "Resincronizar Google Sheets",
          },
          status: {
            pending: "Pendiente",
            processing: "Procesando",
            indexed: "Indexado",
            error: "Error",
            active: "Activo",
            importing: "Importando",
          },
          columnTypes: {
            text: "Texto",
            number: "Número",
            currency: "Moneda",
            date: "Fecha",
            boolean: "Sí/No",
            url: "URL / Enlace",
            image: "Imagen (URL)",
            email: "E-mail",
            phone: "Teléfono",
            select: "Lista de opciones",
            textarea: "Texto largo",
            json: "JSON",
          },
          importModes: {
            csv: "Archivo CSV",
          },
          modes: {
            ask: "Pregunta",
            internal: "Interno",
          },
          toasts: {
            created: "Dataset creado!",
            deleted: "Dataset eliminado!",
            noSourceUrl: "Este dataset no tiene URL de origen para resincronizar.",
            fillImportSource: "Completa la URL de Google Sheets o selecciona un archivo CSV.",
            imported: "Datos importados con éxito!",
            resyncing: "Resincronizando datos de Google Sheets...",
            resynced: "Datos resincronizados!",
            columnAdded: "Columna agregada!",
          },
          confirm: {
            deleteDataset: "¿Eliminar este dataset y todos sus datos?",
            removeColumn: "¿Eliminar la columna \"{{column}}\"? Se perderán los datos de esa columna.",
          },
          form: {
            name: "Nombre",
            catalogName: "Nombre del catálogo",
            description: "Descripción (opcional)",
            fieldName: "Nombre del campo",
            type: "Tipo",
            googleSheetsLink: "Link de Google Sheets",
            csvPlaceholder: "Haz clic para seleccionar archivo CSV",
            newFieldPlaceholder: "Nuevo campo...",
          },
        },
      },
      flowbuilderModal: {
        flowNotIdPhrase: "Flujo predeterminado",
        title: {
          add: "Agregar Flujo",
          edit: "Editar Flujo"
        },
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          required: "¡Ingresa un nombre!"
        }
      },
      queueModal: {
        title: {
          queueData: "Datos de la cola",
          text: "Horario de atención",
          add: "Agregar cola",
          edit: "Editar cola",
          confirmationDelete: "¿Está seguro? Todas las opciones de integraciones serán eliminadas."
        },
        info: {
          intro: {
            title: "ⓘ Qué es una cola",
            text: "Las <strong>colas</strong> (departamentos) organizan la atención. Cada conexión puede vincularse a una o varias colas, y los agentes solo ven tickets de las colas en las que son miembros.<ul><li>Define <strong>nombre</strong> y <strong>color</strong> para identificar la cola visualmente.</li><li>El <strong>mensaje de bienvenida</strong> se envía cuando el cliente entra en esta cola.</li><li>El <strong>enrutador</strong> distribuye automáticamente los tickets entre los agentes en línea.</li></ul><strong>Para automatización avanzada</strong>, usa <em>FlowBuilder</em> y selecciona el flujo en la conexión de WhatsApp."
          }
        },
        sections: {
          identity: "Identificación",
          identityDesc: "Nombre, color y orden de visualización de la cola.",
          behavior: "Comportamiento",
          behaviorDesc: "Define acciones automáticas cuando el ticket entra o se asigna a esta cola.",
          messages: "Mensajes automáticos",
          messagesDesc: "Textos enviados automáticamente en momentos específicos de la atención."
        },
        help: {
          name: "Nombre interno de la cola. Aparece en listas e informes. Usa algo descriptivo (ej: 'Soporte', 'Ventas BR').",
          color: "Color de la etiqueta visual de la cola. Aparece en listas de tickets, chat e informes.",
          orderQueue: "Posición numérica de esta cola en los menús del bot. Las colas con número menor aparecen antes. Usa 0 para ocultar.",
          closeTicket: "Cuando está activado, el ticket se cierra automáticamente al final del flujo del bot. Útil para FAQs y atención 100% automatizada.",
          rotate: "Enrutador automático: redistribuye los tickets sin agente asignado entre los agentes en línea de la cola cada X minutos.",
          tempoRoteador: "Intervalo (en minutos) entre cada redistribución automática. Recomendado: 5 a 10 minutos.",
          greetingMessage: "Texto enviado al cliente cuando el ticket entra en esta cola. Puede incluir variables como {{name}} (nombre del contacto) y {{queue}}."
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la cola (Bot)",
          rotate: "Rotación",
          timeRotate: "Tiempo de Rotación",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          outOfHoursMessage: "Mensaje de fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Lista de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menú",
          message: "Mensaje de retorno",
          queue: "Cola para transferencia",
          integration: "Integración",
          file: "Archivo",
          selectFile: "Seleccione un archivo",
          timeOptions: {
            minutes2: "2 minutos",
            minutes5: "5 minutos",
            minutes10: "10 minutos",
            minutes15: "15 minutos",
            minutes30: "30 minutos",
            minutes45: "45 minutos",
            minutes60: "60 minutos",
          },
        },
        validations: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          required: "Requerido",
          mustHaveFriends: "Debe tener amigos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue opciones para construir un chatbot",
          toolTip: "Si hay solo una opción, se elegirá automáticamente, haciendo que el bot responda con el mensaje de la opción y siga adelante",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Cola",
          integration: "Integración",
          file: "Archivo",
          toolTipMessageTitle: "El mensaje es obligatorio para seguir al siguiente nivel",
          toolTipMessageContent: "El mensaje es obligatorio para seguir al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Cola",
          selectIntegration: "Seleccione una Integración",
          addOptions: "Agregar opciones",
          confirmationDelete: "¿Está seguro? Todas las opciones internas también serán eliminadas",
          messageLabel: "Mensaje:",
          toolTipMessage: "El mensaje es obligatorio para seguir al siguiente nivel",
          toolTipContent: "Si el mensaje no está definido, el bot no seguirá adelante",
        },
        serviceHours: {
          dayWeek: "Día de la semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
          sunday: "Domingo"
        },
        general: {
          none: "Ninguno",
          message: "Mensaje:",
        },
      },
      colorBoxModal: {
        title: "Elige un color",
        eyeDropper: "Capturar color de la pantalla",
        buttons: {
          cancel: "Cancelar",
          ok: "OK",
        },
        tooltips: {
          copy: "Copiar color",
          copied: "¡Copiado!",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto"
        },
        info: {
          intro: {
            title: "ⓘ Qué son las integraciones de flujo",
            text: "Las integraciones conectan esta plataforma a sistemas externos de automatización:<ul><li><strong>N8N:</strong> orquestador de flujos visual — creas automatizaciones con disparadores, condiciones y acciones que se activan en cada mensaje recibido.</li><li><strong>Typebot:</strong> constructor de chatbots conversacionales — el cliente habla con un flujo guiado de preguntas y respuestas predefinidas.</li></ul><strong>Cómo funciona:</strong> al recibir un mensaje, el sistema envía los datos a la URL configurada y procesa la respuesta retornada. La integración se selecciona por conexión en la pestaña <em>Integraciones</em> del whatsapp."
          }
        },
        sections: {
          type: "Tipo de integración",
          typeDesc: "Elige el servicio externo que procesará los mensajes.",
          n8nConfig: "Configuración de N8N",
          n8nConfigDesc: "Indica un nombre para identificar esta integración y la URL del webhook que recibirá los eventos.",
          typebotConnection: "Conexión con Typebot",
          typebotConnectionDesc: "Identifica la integración e indica el servidor + slug del bot publicado en Typebot.",
          typebotBehavior: "Comportamiento de la conversación",
          typebotBehaviorDesc: "Controla el tiempo de expiración, retraso entre mensajes y palabras clave que cierran o reinician el bot."
        },
        help: {
          name: "Nombre interno para identificar esta integración en la lista (ej: 'Bot atención N8N').",
          urlN8N: "URL completa del webhook de tu flujo en N8N. Encuéntralo en: nodo Webhook → 'Production URL'. Debe ser accesible públicamente por el backend de esta plataforma.",
          urlTypebot: "URL base del servidor Typebot (ej: 'https://typebot.io' para la versión oficial o el dominio de tu instancia self-hosted).",
          typebotSlug: "Identificador público del bot publicado. Encuéntralo en la pestaña Share de tu Typebot — es la parte final de la URL (ej: 'mi-bot-123').",
          typebotExpires: "Tiempo (en horas) que la sesión del bot permanece activa sin un nuevo mensaje del contacto. Tras ese período, el flujo se reinicia. Usa 0 para nunca expirar.",
          typebotDelayMessage: "Tiempo (en ms) que el bot espera antes de enviar cada respuesta. Simula escritura humana. Recomendado: 1000-2000ms.",
          typebotKeywordFinish: "Palabra que, cuando la envía el cliente, finaliza inmediatamente el flujo del bot y libera la atención humana (ej: 'salir', 'agente').",
          typebotKeywordRestart: "Palabra que reinicia el flujo del bot desde cero (ej: 'reiniciar', 'menú'). El cliente vuelve a la primera pregunta del Typebot.",
          typebotUnknownMessage: "Mensaje que el bot envía cuando recibe una respuesta que no entiende o que no coincide con ninguna opción del flujo (ej: '¿No entendí, puedes reformular?').",
          typebotRestartMessage: "Mensaje enviado automáticamente cuando el flujo se reinicia por la palabra clave anterior (ej: '¡Empecemos de nuevo!')."
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "Contenido Json",
          urlN8N: "URL",
          urlN8NWebhook: "URL del Webhook (del N8N)",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar el ticket",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot"
        },
        languages: {
          "pt-BR": "Portugués",
          "en": "Inglés",
          "es": "Español",
        },
        instructions: {
          n8nTitle: "Cómo configurar la integración con N8N (paso a paso)",
          n8nStep1: "En tu N8N, crea un nuevo workflow y agrega un nodo \"Webhook\" como primer nodo (trigger).",
          n8nStep2: "En el nodo Webhook, configura el método como POST. N8N generará una URL como: https://tu-n8n.com/webhook/abc123",
          n8nStep3: "Copia esa URL del webhook y pégala en el campo \"URL del Webhook\" arriba.",
          n8nStep4: "Construye el resto de tu workflow en N8N (ej: conectar a una IA, consultar base de datos, enviar correo, etc).",
          n8nStep5: "Después de guardar aquí, ve a Conexiones (WhatsApp) o Colas y vincula esta integración. Cada mensaje recibido en esa conexión/cola se enviará automáticamente a N8N.",
          n8nDataTitle: "Datos que N8N recibirá:",
          n8nReplyTitle: "Cómo N8N responde al cliente:",
          n8nReplyOption1: "Opción 1 (más simple) - En el último nodo del workflow, usa \"Respond to Webhook\" y retorna:",
          n8nReplyOption2: "Opción 2 (más control) - Usa el nodo \"HTTP Request\" para llamar a la API directamente. Los datos apiToken y apiUrl ya vienen en el webhook:",
          n8nTip: "Consejo: El token de la API está en Conexiones > editar la conexión WhatsApp > campo Token. Pero con la Opción 1 de arriba, no necesitas preocuparte por eso - solo retorna el texto en \"reply\".",
          webhookTitle: "Cómo configurar el Webhook",
          webhookStep1: "Configura tu sistema externo para recibir solicitudes POST en el endpoint deseado.",
          webhookStep2: "Pega la URL del endpoint en el campo de arriba. Cada mensaje recibido se enviará como POST con los datos del contacto, ticket y mensaje.",
          webhookStep3: "Si el endpoint retorna { \"reply\": \"texto\" } en la respuesta, el sistema enviará automáticamente ese mensaje al cliente en WhatsApp.",
        },
        messages: {
          testSuccess: "¡Integración probada con éxito!",
          addSuccess: "Integración agregada con éxito.",
          editSuccess: "Integración editada con éxito."
        }
      },
      userModal: {
        warning: "¡Para hacer la importación de los mensajes es necesario leer el qrCode nuevamente !!!",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar imagen",
          removeImage: "Eliminar imagen"
        },
        form: {
          name: "Nombre",
          none: "Ninguna",
          email: "Correo electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabajo",
          endWork: "Fin de trabajo",
          whatsapp: "Conexión Predeterminada",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Deshabilitado",
          allTicket: "Visualizar llamadas sin cola",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menú predeterminado",
          defaultTheme: "Tema Predeterminado",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversaciones de otras colas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Deshabilitado",
          allUserChat: "Ver conversaciones de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Panel de Atendimientos",
          allowConnections: "Permitir acciones en las conexiones",
          canViewAllContacts: "Visualizar Todos los Contactos"
        },
        tabs: {
          general: "General",
          permissions: "Permisos"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen"
        },
        success: "Usuario guardado con éxito."
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa"
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
          status: "Activo"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Empresa guardada con éxito.",
        validations: {
          nameRequired: "El nombre es obligatorio",
          emailInvalid: "El email es inválido",
          emailRequired: "El email es obligatorio",
          passwordRequired: "La contraseña es obligatoria",
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
        },
      },
      scheduleModal: {
        title: {
          add: "Nueva Programación",
          edit: "Editar Programación"
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha de Programación",
          sentAt: "Fecha de Envío",
          assinar: "Enviar Firma",
          date: "Fecha",
          time: "Hora",
          timezoneHelper: "Zona horaria: {{tz}} | Hora actual: {{time}}",
          timezoneHelperShort: "Zona horaria: {{tz}}"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addSchedule: "Agregar programación"
        },
        success: "Programación guardada con éxito.",
        validations: {
          tooShort: "Mensaje muy corto",
          required: "Obligatorio",
          notPast: "La fecha no puede estar en el pasado."
        },
        toasts: {
          deleted: "Media eliminada con éxito."
        },
        confirmationModal: {
          deleteTitle: "Eliminar Media",
          deleteMessage: "¿Estás seguro de que quieres eliminar esta media?"
        },
        status: {
          sending: "Enviando",
          pending: "Pendiente",
          sent: "Enviado",
          error: "Error de Envío"
        },
        recurrence: {
          title: "Recurrencia",
          description: "Puedes elegir enviar el mensaje de forma recurrente y elegir el intervalo. Si es un mensaje único, no cambies nada en esta sección.",
          interval: "Intervalo",
          intervalValue: "Valor del Intervalo",
          sendTimes: "Enviar cuántas veces",
          intervalTypes: {
            days: "Días",
            weeks: "Semanas",
            months: "Meses",
            minutes: "Minutos"
          },
          businessDays: {
            normal: "Enviar normalmente en días no laborables",
            before: "Enviar un día laborable antes",
            after: "Enviar un día laborable después"
          }
        },
        calendar: {
          messages: {
            date: "Fecha",
            time: "Hora",
            event: "Evento",
            allDay: "Todo el Día",
            week: "Semana",
            work_week: "Programaciones",
            day: "Día",
            month: "Mes",
            previous: "Anterior",
            next: "Siguiente",
            yesterday: "Ayer",
            tomorrow: "Mañana",
            today: "Hoy",
            agenda: "Agenda",
            noEventsInRange: "No hay programaciones en el período.",
            showMore: "más"
          }
        },
        permissions: {
          noAccess: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo."
        }
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
          addKanban: "Nueva Columna",
          editKanban: "Editar Columna"
        },
        form: {
          name: "Nombre",
          color: "Color",
          timeLane: "Tiempo en horas para redirigir a la columna",
          timeOnLane: "Tiempo en la columna",
          days: "Días",
          hours: "Horas",
          minutes: "Minutos",
          seconds: "Segundos",
          nextLaneId: "Columna siguiente",
          greetingMessageLane: "Mensaje de bienvenida de la columna",
          rollbackLaneId: "Volver a la Columna después de retomar la atención"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        validation: {
          tooShort: "¡Demasiado corto!",
          required: "Obligatorio"
        },
        success: "Etiqueta guardada con éxito.",
        successKanban: "Columna guardada con éxito."
      },
      fileModal: {
        title: {
          add: "Agregar lista de archivos",
          edit: "Editar lista de archivos"
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo"
        },
        form: {
          name: "Nombre de la lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de la opción"
        },
        success: "¡Lista de archivos guardada con éxito!"
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para comenzar a conversar.",
        deleteConversationTitle: "Eliminar Conversación",
        deleteConversationMessage: "Esta acción no se puede revertir, ¿confirmar?",
        messagePlaceholder: "Escribe tu mensaje...",
        sendButtonTooltip: "Enviar mensaje",
        noMessagesYet: "Aún no hay mensajes. ¡Comienza la conversación!",
        loadingMessages: "Cargando mensajes...",
        popover: {
          buttonTooltip: "Conversaciones internas",
          loading: "Cargando conversaciones...",
          noChats: "No hay conversaciones disponibles",
          notificationNotSupported: "Este navegador no admite notificaciones",
          accessibilityLabel: "Lista de conversaciones internas",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ ARRASTRA Y SUELTA ARCHIVOS EN EL CAMPO ABAJO ⬇️",
          titleFileList: "Lista de archivo(s)"
        }
      },
      chatInternal: {
        new: "Nueva",
        tabs: {
          chats: "Chats",
          messages: "Mensajes",
        },
        form: {
          titleLabel: "Título",
          titlePlaceholder: "Título",
        },
        modal: {
          conversation: "Conversación",
          title: "Título",
          filterUsers: "Filtrar por Usuarios",
          cancel: "Cerrar",
          save: "Guardar"
        },
        modalDelete: {
          title: "Eliminar Conversación",
          message: "Esta acción no se puede revertir, ¿confirmar?"
        }
      },
      ticketsManager: {
        questionCloseTicket: "¿DESEAS CERRAR TODOS LOS TICKETS?",
        yes: "SÍ",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolveAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo"
        }
      },
      ticketsQueueSelect: {
        placeholder: "Colas"
      },
      tickets: {
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SÍ",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos"
        },
        toasts: {
          deleted: "El atención que estabas fue eliminado."
        },
        notification: {
          message: "Mensaje de"
        },
        tabs: {
          open: {
            title: "Abiertas"
          },
          closed: {
            title: "Resueltos"
          },
          search: {
            title: "Búsqueda"
          }
        },
        search: {
          placeholder: "Buscar atención y mensajes",
          filterConections: "Filtrar por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente"
          },
          filterUsers: "Filtrar por Usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Tickets por página"
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a la Cola",
          scredule: "Programación",
          deleteTicket: "Eliminar Ticket",
          quickMessageFlash: "Respuestas rápidas"
        },
        noContactName: "(sin contacto)",
        noDepartment: "Sin departamento",
        group: "Grupo",
        transferTooltip: "Transferir Ticket",
        closedTicket: {
          closedMessage: "Cerrar Ticket Con Mensaje de Despedida",
          closedNotMessage: "Cerrar Ticket Sin Mensaje de Despedida"
        }
      },
      messages: {
        download: "Descargar",
        today: "HOY",
        contact: "Contacto",
        forwarded: "Reenviado",
        deletedByContact: "🚫 Este mensaje fue eliminado por el contacto &nbsp;",
        deletedMessage: "🚫 _Mensaje eliminado_ ",
        deletedBySender: "🚫 Este mensaje fue eliminado &nbsp;",
        youReacted: "Reaccionaste... ",
        sayHello: "¡Saluda a tu nuevo contacto!",
        dropFile: "Suelta el archivo aquí",
        facebookPolicy: "Tienes 24h para responder después de recibir un mensaje, según las políticas de Facebook.",
        defaultMetaMessage: "¡Hola! Estoy interesado y me gustaría más información, por favor.",
      },
      ticketsResponsive: {
        search: {
          searchInMessagesTooltip: "Marca para buscar también en el contenido de los mensajes (más lento)",
        },
        filter: {
          all: "Todos",
          unreplied: "Sin responder",
          title: "Filtros",
          queues: "Colas",
          tags: "Etiquetas",
          connections: "Conexiones",
          status: "Estado",
          users: "Usuarios",
          showTags: "Mostrar etiquetas",
          hideTags: "Ocultar etiquetas",
        },
        sort: {
          ascending: "Ascendente",
          descending: "Descendente",
        },
      },
      contactForm: {
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          required: "Obligatorio",
          invalidEmail: "Email inválido",
        },
        placeholders: {
          number: "5513912344321",
          email: "Dirección de correo",
        },
      },
      common: {
        image: "imagen",
      },
      messageInputResponsive: {
        privateMessage: {
          suffix: "Mensaje Privado",
        },
        type: {
          document: "Documento",
          buttons: "Botones",
        },
        tooltip: {
          toggleSignature: "Habilitar/Deshabilitar Firma",
          toggleComments: "Habilitar/Deshabilitar Comentarios",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escribe para buscar usuarios",
        fieldQueueLabel: "Transferir a cola",
        fieldQueuePlaceholder: "Selecciona una cola",
        fieldWhatsapp: "Selecciona un whatsapp",
        noOptions: "Ningún usuario encontrado con ese nombre",
        msgTransfer: "Observaciones - mensaje interno, no va para el cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar"
        }
      },
      ticketsList: {
        called: "Llamado",
        today: "Hoy",
        missedCall: "Llamada de voz/video perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Atendiendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage: "Ninguna atención encontrada con este estado o término buscado",
        noQueue: "Sin Cola",
        draft: "Borrador:",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar a PDF",
          kanbanActions: "Opciones de Kanban",
          showAll: "Ver Todos",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar sector"
        }
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar el contacto",
        add: "Agregar",
        selectQueue: "Seleccione una cola",
        selectConnection: "Seleccione una Conexión",
        queueError: "Seleccione una cola",
        close: "Cerrar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar"
        },
        form: {
          contact: "Contacto",
          queue: "Cola",
          message: "Mensaje inicial",
          contactPlaceholder: "Buscar contacto...",
          queuePlaceholder: "Seleccionar cola...",
          messagePlaceholder: "Mensaje inicial opcional...",
          connectionPlaceholder: "Seleccione una Conexión..."
        },
        validation: {
          contactRequired: "Debes seleccionar un contacto",
          queueRequired: "Debes seleccionar una cola"
        }
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Escribe para buscar el contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar"
        }
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel",
          tickets: "Atendimientos",
          quickMessages: "Respuestas rápidas",
          contacts: "Contactos",
          queues: "Colas",
          flowbuilder: "Flowbuilder",
          tags: "Etiquetas",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuraciones",
          files: "Lista de archivos",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programaciones",
          campaigns: "Campañas",
          annoucements: "Informativos",
          announcements: "Informativos",
          knowledgeBase: "Base de Conocimiento",
          agentQualification: "Calificación del Agente",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Prompts",
          allConnections: "Administrar conexiones",
          reports: "Informes",
          management: "Análisis"
        },
        appBar: {
          search: "Buscar...",
          user: {
            profile: "Perfil",
            logout: "Salir",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y daré continuidad en tu atención.",
            virtualAssistant: "Asistente Virtual",
            token: "Token inválido, por favor entra en contacto con el administrador de la plataforma."
          },
          message: {
            location: "Ubicación",
            contact: "Contacto"
          },
          notRegister: "Ningún registro",
          refresh: "Actualizar",
          themeLight: "Modo claro",
          themeDark: "Modo oscuro",
          volume: "Volumen",
          volumeNotifications: "Volumen de notificaciones",
          installPwa: {
            title: "Agregar a la pantalla de inicio",
            iosStep1: "Toca el botón Compartir (icono de cuadrado con flecha hacia arriba)",
            iosStep2: "Desplázate y toca \"Agregar a pantalla de inicio\"",
            iosStep3: "Toca \"Agregar\"",
            androidStep1: "Toca el menú del navegador ⋮ (tres puntos de Chrome)",
            androidStep2: "Toca \"Agregar a pantalla de inicio\" o \"Instalar aplicación\"",
            androidStep3: "Confirma tocando \"Instalar\"",
            gotIt: "Entendido"
          }
        }
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Portugués",
        es: "Español",
        en: "English",
        tr: "Türkçe"
      },
      messagesAPI: {
        title: "API",
        subtitle: "Integra sistemas externos para enviar mensajes vía API.",
        methodsSubtitle: "Endpoints disponibles y reglas para el número de destino.",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID del usuario/agente",
          queueId: "ID de la Cola"
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado"
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Media"
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1: "Antes de enviar mensajes, es necesario el registro del token vinculado a la conexión que enviará los mensajes. <br />Para realizar el registro acceda al menú 'Conexiones', haga clic en el botón editar de la conexión e inserte el token en el debido campo.",
            comments2: "El número para envío no debe tener máscara o caracteres especiales y debe ser compuesto por:",
            codeCountry: "Código del País",
            code: "DDD",
            number: "Número"
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions: "Siguen abajo la lista de informaciones necesarias para envío de los mensajes de texto:"
          },
          media: {
            title: "2. Mensajes de Media",
            instructions: "Siguen abajo la lista de informaciones necesarias para envío de los mensajes de texto:"
          }
        },
        messages: {
          noPermission: "Esta empresa no tiene permiso para acceder a esta página! Te estamos redirigiendo.",
          success: "Mensaje enviado con éxito",
        },
        form: {
          send: "Enviar",
          testSend: "Prueba de envío",
          chooseFile: "Elegir archivo",
          noFile: "Ningún archivo seleccionado",
        },
        documentation: {
          endpoint: "Endpoint: ",
          method: "Método: ",
          post: "POST",
          headers: "Headers: ",
          headersTextAuth: "Authorization Bearer (token registrado) y Content-Type (application/json)",
          headersMediaAuth: "Authorization Bearer (token registrado) y Content-Type (multipart/form-data)",
          body: "Body: ",
          formData: "FormData: ",
          bodyExample: "{\n  \"number\": \"558599999999\",\n  \"body\": \"Message\",\n  \"userId\": \"ID usuario o \\\"\\\"\",\n  \"queueId\": \"ID Cola o \\\"\\\"\",\n  \"sendSignature\": \"Firmar mensaje - true/false\",\n  \"closeTicket\": \"Cerrar el ticket - true/false\"\n}",
          formDataFields: {
            number: "number: 558599999999",
            body: "body: Message",
            userId: "userId: ID usuario o \\\"\\\"",
            queueId: "queueId: ID de la cola o \\\"\\\"",
            medias: "medias: archivo",
            sendSignature: "sendSignature: Firmar mensaje true/false",
            closeTicket: "closeTicket: Cerrar ticket true/false",
          },
        },
      },
      notifications: {
        title: "Notificaciones",
        noTickets: "Ninguna notificación.",
        tabs: {
          system: "Sistema",
          chat: "Chat",
          internal: "Interno",
        },
      },
      quickMessages: {
        title: "Respuestas rápidas",
        subtitle: "Atajos para mensajes reutilizables en la atención",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin anexo",
        empty: "No hay respuestas rápidas registradas.",
        global: "Global",
        personal: "Personal",
        kpis: {
          total: "Total",
          withMedia: "Con medios",
          global: "Globales",
          personal: "Personales",
        },
        filters: {
          visibility: "Visibilidad",
          all: "Todas",
          mine: "Mías",
          shared: "Compartidas",
        },
        tooltips: {
          edit: "Editar",
          delete: "Eliminar",
          removeAttachment: "Eliminar adjunto",
        },
        confirmationModal: {
          deleteTitle: "Exclusión",
          deleteMessage: "¡Esta acción es irreversible! ¿Desea proseguir?"
        },
        buttons: {
          add: "Agregar",
          attach: "Anexar Archivo",
          cancel: "Cancelar",
          edit: "Editar"
        },
        toasts: {
          success: "¡Atajo agregado con éxito!",
          deleted: "¡Atajo removido con éxito!"
        },
        dialog: {
          title: "Mensaje Rápido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
          allow: "Permitir",
          disallow: "No permitir",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Ámbito",
          createdBy: "Creado por",
          you: "tú",
          emptyMessage: "—"
        }
      },
      contactLists: {
        title: "Listas de Contactos",
        subtitle: "Organiza bases de contactos para campañas.",
        empty: {
          list: "No hay listas registradas.",
          search: "No se encontró ninguna lista para la búsqueda.",
        },
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Lista",
          downloadSample: "Descargar Plantilla de Ejemplo"
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
          description: "Define un nombre para identificar esta base en campañas e importaciones."
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir."
        },
        toasts: {
          deleted: "Registro eliminado"
        }
      },
      contactListItems: {
        title: "Contactos",
        subtitle: "Gestiona los contactos de esta lista.",
        searchPlaceholder: "Búsqueda",
        empty: {
          list: "No hay contactos registrados en esta lista.",
          search: "No se encontró ningún contacto para la búsqueda.",
        },
        buttons: {
          add: "Nuevo",
          lists: "Listas",
          import: "Importar"
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "WhatsApp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
          description: "Completa los datos del contacto que formará parte de esta lista."
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "WhatsApp",
          email: "E-mail",
          actions: "Acciones"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Desea importar los contactos de esta planilla? ",
          importTitlte: "Importar"
        },
        toasts: {
          deleted: "Registro eliminado"
        },
        downloadTemplate: "Haga clic aquí para descargar plantilla de ejemplo.",
        whatsappValid: "WhatsApp Válido",
        whatsappInvalid: "WhatsApp Inválido"
      },
      kanban: {
        title: "Kanban",
        subtitle: "Visualización de tickets en formato Kanban",
        searchPlaceholder: "Búsqueda",
        subMenus: { list: "Panel", tags: "Lanes" },
        ticketNumber: "Ticket nº ",
        viewTicket: "Ver Ticket",
        startDate: "Fecha de inicio",
        endDate: "Fecha de fin",
        search: "Buscar",
        addColumns: "+ Agregar columnas",
        ticketTagRemoved: "¡Etiqueta de Ticket Eliminada!",
        ticketTagAdded: "¡Etiqueta de Ticket Agregada con Éxito!",
        ticketMoveError: "Error al mover ticket",
        iconChannelError: "Error",
        noTickets: "Ningún ticket",
        emptyBoard: "Tablero vacío — agrega columnas y tickets",
        emptyStateTags: "Ninguna etiqueta Kanban creada",
        emptyStateTagsDescription: "Crea tu primera etiqueta Kanban para comenzar a organizar tickets",
        createFirstTag: "Crear Primera Etiqueta",
        emptyStateTickets: "Ningún ticket encontrado",
        emptyStateTicketsDescription: "Ajusta los filtros de fecha o crea nuevos tickets",
        errorTitle: "Error al cargar Kanban",
        errorDescription: "Ocurrió un error al buscar datos. Inténtalo de nuevo.",
        retry: "Intentar Nuevamente",
        template: "Plantilla",
        common: { close: "Cerrar" },
        addCard: "Agregar card",
        createFirstColumn: "Crear primera columna",
        emptyBoardDescription: "Crea la primera columna para empezar a organizar tus tickets.",
        addColumn: {
          before: "Agregar columna antes",
          after: "Agregar columna después",
          first: "Agregar primera columna",
          edit: "Editar columna",
        },
        laneLock: {
          systemDefaultTooltip: "Columna predeterminada del sistema — necesaria para el tracking, no se puede eliminar.",
          dealOutcomeTooltipTemplate: "Columna marcada como etapa de resultado ({{outcome}}). Quita el resultado primero para eliminar.",
          mappingTooltipTemplate: "En uso por mapping(s) de tracking: {{names}}.",
          protectedTooltip: "Columna protegida.",
          systemDefaultLabel: "Columna predeterminada (sistema)",
          dealOutcomeLabel: "Etapa de resultado",
          mappingLabel: "En uso por mapping",
          protectedLabel: "Columna protegida",
          dealWon: "Venta ganada",
          dealLost: "Venta perdida",
        },
        budget: {
          fillProductBoth: "Completa nombre y valor del producto",
          fillProductName: "Completa el nombre del producto",
          productLabel: "Producto",
          valueLabel: "Valor",
          total: "Total",
          statuses: {
            approved: "Aprobado",
            budget: "Presupuesto",
            cancelled: "Cancelado",
            negotiating: "Negociando",
            overdue: "Atrasado",
            paid: "Pagado",
            partial: "Pagado parcialmente",
            pending: "Pendiente",
            refunded: "Reembolsado",
            rejected: "Rechazado",
          },
        },
        card: {
          budget: "Presupuestos",
          followUp: "Seguimiento",
          notes: "Notas",
          tags: "Etiquetas",
          openChat: "Abrir conversación",
          moveNext: "Mover a la siguiente",
          noMessages: "Sin mensajes",
          noName: "Sin nombre",
          scheduledMessage: "Mensaje programado",
          menu: "Más opciones",
          editSchedule: "Editar programación",
          deleteSchedule: "Eliminar programación",
          media: {
            audio: "Audio",
            contact: "Contacto",
            document: "Documento",
            image: "Imagen",
            location: "Ubicación",
            sticker: "Sticker",
            video: "Video",
          },
        },
        cardMenu: {
          closeTicket: "Cerrar ticket",
          contactDetails: "Detalles del contacto",
          deleteLead: "Eliminar lead",
          editContact: "Editar contacto",
          markLost: "Marcar como Perdido",
          markWon: "Marcar como Ganado",
          moveCard: "Mover card",
          moveToBoard: "Mover a otro tablero",
          mute: "Silenciar",
          transfer: "Transferir",
          unmute: "Reactivar sonido",
        },
        contactDrawer: { title: "Contacto" },
        currency: { title: "Moneda", searchPlaceholder: "Buscar moneda" },
        deal: {
          boardOptional: "Tablero destino (opcional)",
          columnOptional: "Columna destino (opcional)",
          confirm: "Confirmar",
          loadingColumns: "Cargando columnas…",
          lostReason: "Motivo de la pérdida",
          markLost: "Marcar como Perdido",
          markWon: "Marcar como Ganado",
          notesLabel: "Notas",
          selectReason: "Selecciona un motivo",
          selectReasonTooltip: "Elige un motivo para confirmar",
          winReason: "Motivo de la ganancia",
        },
        deleteBoardDialog: {
          body: "Esta acción no se puede deshacer. ¿Confirmas?",
          titleTemplate: "Eliminar tablero \"{{name}}\"",
        },
        deleteColumnDialog: {
          columnHasCardsBefore: "Esta columna tiene",
          columnHasCardsAfter: "card(s). ¿A dónde transferirlos?",
          confirmBodyBefore: "¿Eliminar la columna",
          confirmBodyAfter: "? Esta acción no se puede deshacer.",
          delete: "Eliminar",
          deleteAndTransfer: "Eliminar y transferir",
          selectColumnPlaceholder: "Selecciona la columna destino",
          selectDestination: "Columna destino",
          titleTemplate: "Eliminar columna \"{{name}}\"",
        },
        deleteTicket: {
          alsoDeleteContact: "También eliminar el contacto",
          body: "Esta acción no se puede deshacer. ¿Confirmas?",
          saveOnly: "Eliminar lead",
          saveWithContact: "Eliminar lead y contacto",
          titleGeneric: "Eliminar ticket",
          titleTemplate: "Eliminar lead de \"{{name}}\"",
        },
        filters: {
          title: "Filtros",
          attendants: "Operadores",
          connections: "Conexiones",
          queues: "Colas",
          status: "Estado",
          tags: "Etiquetas",
          unreplied: "Sin respuesta",
          clearAll: "Limpiar filtros",
          apply: "Aplicar",
          tabs: { all: "Todos", group: "Grupos", open: "Abiertos", pending: "Pendientes" },
        },
        followUp: {
          fillDiscussedTooltip: "Describe lo que se trató",
          nextReturnLabel: "Próximo retorno",
          past: "Anteriores",
          registerButton: "Registrar seguimiento",
          timeLabel: "Hora",
          title: "Seguimientos",
          upcoming: "Próximos",
          whatWasDiscussedLabel: "Qué se discutió",
        },
        laneMenu: {
          addAfter: "Agregar columna después",
          addBefore: "Agregar columna antes",
          addCard: "Agregar card",
          deleteColumn: "Eliminar columna",
          edit: "Editar columna",
          rename: "Renombrar",
        },
        leadSource: { indicacao: "Recomendación" },
        moveBoard: {
          board: "Tablero",
          column: "Columna",
          loadingColumns: "Cargando columnas…",
          move: "Mover",
          title: "Mover a otro tablero",
        },
        newBoard: {
          nameLabel: "Nombre del tablero",
          save: "Guardar",
          saving: "Guardando…",
          selectBoardPlaceholder: "Selecciona un tablero",
          templateEmpty: "En blanco",
          templatePostSales: "Postventa",
          title: "Nuevo tablero",
        },
        notes: {
          newLabel: "Nueva nota",
          typePlaceholder: "Escribe una nota y presiona Enter",
        },
        schedule: {
          newScheduled: "Nuevo mensaje programado",
          noBody: "Sin texto",
          title: "Programaciones",
        },
        toasts: {
          boardDeleted: "Tablero eliminado",
          transferCardsBeforeDelete: "Transfiere los cards antes de eliminar el tablero",
        },
        tooltips: {
          deleteBoard: "Eliminar tablero",
          enterFullscreen: "Pantalla completa",
          exitFullscreen: "Salir de pantalla completa",
          newBoard: "Nuevo tablero",
          sortAsc: "Ordenar ascendente",
          sortDesc: "Ordenar descendente",
          viewAll: "Ver todos",
          viewOnlyMine: "Ver solo los míos",
        },
      },
      campaigns: {
        title: "Campañas",
        subtitle: "Crea y acompaña envíos programados para listas de contactos.",
        empty: {
          list: "Ninguna campaña registrada.",
          search: "Ninguna campaña encontrada para la búsqueda.",
        },
        status: {
          inactive: "Inactiva",
          scheduled: "Programada",
          inProgress: "En curso",
          cancelled: "Cancelada",
          finished: "Finalizada",
        },
        common: {
          none: "Ninguna",
          notDefined: "No definida",
          noSchedule: "Sin programación",
          notCompleted: "No concluida",
          enabled: "Habilitada",
          disabled: "Deshabilitada",
        },
        modal: {
          tabLabels: {
            msg1: "Msg. 1",
            msg2: "Msg. 2",
            msg3: "Msg. 3",
            msg4: "Msg. 4",
            msg5: "Msg. 5",
          },
          helpText: "Utiliza variables como {nome}, {numero}, {email} o define variables personalizadas.",
        },
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listado",
          listContacts: "Lista de contactos",
          settings: "Configuraciones"
        },
        settings: {
          randomInterval: "Intervalo Aleatorio de Disparo",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de disparo mayor",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido"
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listas de contactos",
          stopCampaign: "Parar Campaña",
          restartCampaign: "Reiniciar campaña",
          report: "Informe",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Lista de contactos",
          option: "Ninguna",
          disabled: "Deshabilitada",
          enabled: "Habilitada",
          status: "Estado",
          scheduledAt: "Programación",
          completedAt: "Concluida",
          confirmation: "Confirmación",
          actions: "Acciones"
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Apenas Visualización",
          help: "Utiliza variables como {nome}, {numero}, {email} o define variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programación",
            confirmation: "Confirmación",
            contactList: "Lista de contactos",
            tagList: "Etiquetas",
            statusTicket: "Estado del ticket",
            openTicketStatus: "Abierto",
            pendingTicketStatus: "Pendiente",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Deshabilitado",
            openTicket: "Abrir ticket"
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Cerrar",
            attach: "Adjuntar archivo"
          }
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir."
        },
        toasts: {
          success: "Operación realizada con éxito",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro eliminado"
        },
        noPermission: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo.",
      },
      campaignReport: {
        title: "Informe de",
        subtitle: "Acompaña el progreso y los resultados de la campaña",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En curso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregados",
        connection: "Conexión",
        contactLists: "Lista de Contactos",
        schedule: "Programación",
        conclusion: "Conclusión",
        noPermission: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo.",
        status: "Estado:",
        of: "de",
      },
      announcements: {
        title: "Informativos",
        subtitle: "Gestiona los informativos enviados a los usuarios de la plataforma.",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        empty: {
          search: "Ningún informativo coincide con la búsqueda.",
          list: "Ningún informativo registrado.",
        },
        buttons: {
          add: "Nuevo Informativo",
          contactLists: "Listas de Informativos"
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones"
        },
        dialog: {
          edit: "Edición de Informativo",
          add: "Nuevo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualización",
          subtitle: "Define el título, contenido, estado y prioridad del informativo mostrado a los usuarios.",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
            high: "Alta",
            medium: "Media",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo"
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo"
          }
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir."
        },
        toasts: {
          success: "Operación realizada con éxito",
          deleted: "Registro eliminado",
          noPermission: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo."
        }
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
        noPermissionMessage: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo.",
        settingsSaved: "Configuraciones guardadas",
        intervals: "Intervalos",
        intervalDescription: "Define los intervalos usados en el envío automático de las campañas.",
        seconds: "segundos",
      },
      campaignsPhrase: {
        title: "Campañas",
        subtitle: "Gestiona campañas activadas por frases",
        phraseDeleted: "Frase eliminada",
        phraseUpdated: "¡Frase modificada con éxito!",
        phraseCreated: "¡Frase creada con éxito!",
        addCampaign: "Campaña",
        table: {
          name: "Nombre",
          status: "Estado",
          active: "Activo",
          inactive: "Desactivado",
          empty: "No se encontraron campañas por frase",
          emptySearch: "Ninguna campaña coincide con la búsqueda.",
        },
        modal: {
          editTitle: "Editar campaña con flujo por frase",
          newTitle: "Nueva campaña con flujo por frase",
          nameLabel: "Nombre del disparo por frase",
          flowLabel: "Elige un flujo",
          flowPlaceholder: "Elige un flujo",
          connectionPlaceholder: "Selecciona una Conexión",
          phraseLabel: "¿Qué frase dispara el flujo?",
          matchTypeLabel: "Tipo de coincidencia",
          matchTypeExact: "Coincidencia Exacta",
          matchTypeContains: "Contiene la palabra",
          matchTypeTooltip: "Exacta: el mensaje debe ser igual a la palabra. Contiene: la palabra puede aparecer en cualquier parte del mensaje",
          statusLabel: "Estado",
          cancelButton: "Cancelar",
          saveButton: "Guardar campaña",
          createButton: "Crear campaña",
        },
      },
      queues: {
        title: "Colas",
        subtitle: "Departamentos para organizar y distribuir los tickets entre los agentes",
        empty: "Ninguna cola registrada.",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de bienvenida",
          orderQueue: "Ordenación de la cola (bot)",
          actions: "Acciones",
          ID: "ID"
        },
        buttons: {
          add: "Agregar cola",
          edit: "Editar",
          delete: "Eliminar"
        },
        toasts: {
          success: "Cola guardada con éxito",
          deleted: "Cola eliminada con éxito",
          queueDeleted: "¡Cola eliminada con éxito!",
          botSaved: "Bot guardado con éxito",
          clickToSave: "Haga clic en guardar para registrar los cambios",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no se puede revertir! Los tickets de esta cola seguirán existiendo, pero ya no tendrán ninguna cola asignada."
        }
      },
      queue: {
        queueData: "Datos"
      },
      queueSelect: {
        inputLabel: "Colas",
        inputLabelRO: "Colas de solo lectura",
        withoutQueue: "Sin cola",
        undefined: "Cola no encontrada",
        errors: {
          loadError: "QUEUESELETSINGLE >>>"
        }
      },
      queueIntegration: {
        title: "Integraciones",
        subtitle: "Conecta flujos automatizados externos como N8N y Typebot",
        empty: "Ninguna integración registrada.",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Última actualización",
          actions: "Acciones"
        },
        buttons: {
          add: "Agregar Proyecto",
          edit: "Editar",
          delete: "Eliminar"
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir! y será eliminada de las colas y conexiones vinculadas"
        },
        toasts: {
          deleted: "¡Integración eliminada con éxito!",
        },
        messages: {
          noPermission: "¡Esta empresa no tiene permiso para acceder a esta página! Te estamos redirigiendo.",
        },
      },
      users: {
        title: "Usuarios",
        subtitle: "Gestione los agentes, perfiles y permisos de su equipo",
        empty: "Ningún usuario registrado.",
        table: {
          status: "Estado",
          avatar: "Avatar",
          name: "Nombre",
          email: "Correo electrónico",
          profile: "Perfil",
          startWork: "Inicio de trabajo",
          endWork: "Fin de trabajo",
          actions: "Acciones",
          ID: "ID"
        },
        profile: {
          admin: "Admin",
          user: "Usuario",
        },
        status: {
          enabled: "Habilitado",
          disabled: "Deshabilitado",
        },
        upload: {
          avatar: "Subir Avatar",
        },
        buttons: {
          add: "Agregar usuario",
          edit: "Editar",
          delete: "Eliminar",
        },
        toasts: {
          deleted: "Usuario eliminado con éxito."
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Todos los datos del usuario se perderán. Las atenciones abiertas de este usuario se moverán a la cola."
        }
      },
      compaies: {
        title: "Empresas",
        subtitle: "Administre todas las empresas (tenants) de la plataforma",
        actions: {
          new: "Nueva empresa",
        },
        modal: {
          createTitle: "Nueva empresa",
          editTitle: "Editar empresa",
          cancel: "Cancelar",
          incrementDueDate: "Avanzar vencimiento según recurrencia",
        },
        empty: {
          list: "Aún no hay empresas registradas.",
          search: "Ninguna empresa coincide con la búsqueda.",
        },
        due: {
          expired: "Vencida",
        },
        form: {
          documentLabel: "CPF/CNPJ (opcional)",
          documentPlaceholder: "000.000.000-00 o 00.000.000/0000-00",
          documentInvalid: "CPF/CNPJ inválido",
          documentDuplicate: "CPF/CNPJ ya registrado",
          documentNotProvided: "No informado",
          nameRequired: "Nombre es obligatorio",
          emailRequired: "Correo electrónico es obligatorio",
        },
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programación",
          createdAt: "Creada En",
          dueDate: "Vencimiento",
          lastLogin: "Últ. Login",
          actions: "Acciones",
          money: "€",
          yes: "Sí",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
          folderSize: "Tamaño Carpeta",
          totalFiles: "Total Archivos",
          lastUpdate: "Última Actualización",
        },
        searchPlaceholder: "Buscar empresas...",
        searchLabel: "Campo de búsqueda de empresas",
        clearSearch: "Limpiar búsqueda",
        buttons: {
          add: "Agregar empresa"
        },
        toasts: {
          deleted: "Empresa eliminada con éxito."
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Todos los datos de la empresa se perderán. Los tickets abiertos de este usuario se moverán a la cola."
        },
        notifications: {
          noPermission: "¡Esta empresa no tiene permisos para acceder a esta página! Te estamos redirigiendo."
        },
      },
      plans: {
        title: "Planes",
        subtitle: "Gestiona los planes disponibles en la plataforma",
        actions: {
          new: "Nuevo plan",
        },
        empty: {
          search: "Ningún plan coincide con la búsqueda.",
          list: "Ningún plan registrado.",
        },
        table: {
          actions: "Acciones",
        },
        modal: {
          createTitle: "Nuevo plan",
          editTitle: "Editar plan",
          cancel: "Cancelar",
          billingType: "Tipo de cobro",
          billingTypes: {
            single: "Único",
            recurring: "Recurrente",
            free: "Gratis",
          },
          recurrence: "Recurrencia",
          recurrences: {
            weekly: "Semanal",
            biweekly: "Quincenal",
            monthly: "Mensual",
            quarterly: "Trimestral",
            semiannual: "Semestral",
            annual: "Anual",
          },
          resources: "Recursos",
          markAll: "Marcar todo",
          unmarkAll: "Desmarcar todo",
        },
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programaciones",
          enabled: "Habilitadas",
          disabled: "Deshabilitadas",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "€",
          public: "Público"
        }
      },
      helps: {
        title: "Central de Ayuda",
        subtitle: "Registra videos de YouTube que se muestran en la Central de Ayuda de los usuarios.",
        thumbnail: "Miniatura",
        videoPlayerTitle: "Reproductor de video de YouTube",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar"
        },
        form: {
          newTitle: "Registrar nuevo video",
          editTitle: "Editar video",
          titleLabel: "Título",
          titlePlaceholder: "Ej: Cómo configurar WhatsApp",
          linkLabel: "Enlace de YouTube",
          linkPlaceholder: "https://www.youtube.com/watch?v=...",
          descriptionLabel: "Descripción",
          descriptionPlaceholder: "Breve resumen sobre lo que enseña el video",
          invalidLink: "Enlace inválido. Pega la URL completa de YouTube."
        },
        table: {
          title: "Título",
          description: "Descripción",
          video: "Video",
          actions: "Acciones"
        },
        empty: {
          list: "Aún no hay videos registrados.",
          search: "Ningún video encontrado para la búsqueda."
        },
        tooltips: {
          title: {
            description: "Nombre corto y directo que el usuario verá en la tarjeta de la Central de Ayuda.",
            steps: [
              "Usa 5 a 8 palabras describiendo el tema (ej: \"Cómo crear un flujo en FlowBuilder\").",
              "Evita jerga interna — quien mira es el usuario final.",
              "El título aparece destacado arriba de la descripción en la tarjeta."
            ]
          },
          link: {
            description: "Enlace completo del video en YouTube. El sistema extrae automáticamente el código del video.",
            steps: [
              "Abre el video en YouTube y copia la URL de la barra de direcciones.",
              "Acepta formatos: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/embed/ID y youtube.com/shorts/ID.",
              "Si prefieres, pega solo el ID del video (11 caracteres).",
              "Confirma que el video esté como \"Público\" o \"No listado\" — los privados no se reproducen embebidos."
            ]
          },
          description: {
            description: "Texto auxiliar mostrado debajo del título en la tarjeta de ayuda.",
            steps: [
              "Usa 1–2 frases explicando lo que el usuario va a aprender.",
              "Limita a ~120 caracteres — la tarjeta recorta el resto en 3 líneas.",
              "Opcional, pero recomendado para mejorar la navegación."
            ]
          }
        }
      },
      calendarReminder: {
        startsIn: "empieza en",
        permissionDenied: "Notificaciones bloqueadas. Habilita en el navegador para recibir recordatorios.",
      },
      eventPopover: {
        dateInPast: "La fecha y hora seleccionadas están en el pasado.",
        titleNew: "Nueva agenda",
        titleEdit: "Editar agenda",
        fields: {
          titleLabel: "Título",
          titlePlaceholder: "Ej: Reunión con cliente",
          eventTypeLabel: "Tipo",
          dateLabel: "Fecha",
          allDay: "Todo el día",
          startTimeLabel: "Inicio",
          timeLabel: "Hora",
          durationLabel: "Duración",
          reminderLabel: "Recordatorio",
          locationLabel: "Lugar",
          locationPlaceholder: "Ej: Sala 1, Google Meet",
          descriptionLabel: "Descripción",
          descriptionPlaceholder: "Notas, agenda, enlaces…",
        },
        eventTypes: { meeting: "Reunión", task: "Tarea" },
        durations: {
          min15: "15 minutos", min30: "30 minutos",
          hour1: "1 hora", hour1h30: "1h30", hour2: "2 horas",
          hour3: "3 horas", hour4: "4 horas", hour8: "8 horas",
        },
        reminders: {
          none: "Sin recordatorio", min5: "5 minutos antes", min10: "10 minutos antes",
          min15: "15 minutos antes", min30: "30 minutos antes",
          hour1: "1 hora antes", hour2: "2 horas antes", day1: "1 día antes",
        },
        reminderHint: "Serás recordado {{when}}",
        buttons: { create: "Crear", save: "Guardar" },
      },
      eventDetailPopover: {
        title: "Agenda",
        edit: "Editar",
        delete: "Eliminar",
        allDay: "Todo el día",
        createdBy: "Creado por",
        eventTypes: { meeting: "Reunión", task: "Tarea" },
        reminders: {
          minBefore: "{{count}} minutos antes",
          none: "Sin recordatorio", min5: "5 min antes", min10: "10 min antes",
          min15: "15 min antes", min30: "30 min antes",
          hour1: "1 hora antes", hour2: "2 horas antes", day1: "1 día antes",
        },
      },
      schedules: {
        title: "Programaciones",
        subtitleCount: "mensajes programados",
        subtitleEvents: "agendas",
        calendar: {
          today: "Hoy",
          viewModes: {
            month: "Mes",
            week: "Semana",
            day: "Día",
            year: "Año",
            schedule: "Agenda",
          },
        },
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que quieres eliminar esta Programación?",
          deleteMessage: "Esta acción no se puede revertir."
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha de Programación",
          sentAt: "Fecha de Envío",
          status: "Estado",
          actions: "Acciones"
        },
        buttons: {
          add: "Nuevo mensaje programado",
          addShort: "+ Mensaje",
          addEvent: "Crear agenda",
          addEventShort: "+ Agenda"
        },
        toasts: {
          deleted: "Programación eliminada con éxito.",
          eventCreated: "Agenda creada con éxito.",
          eventUpdated: "Agenda actualizada con éxito.",
          eventDeleted: "Agenda eliminada con éxito."
        }
      },
      tags: {
        title: "Tags",
        subtitle: "Organiza tus contactos con etiquetas coloridas",
        empty: "No hay tags registradas.",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que quieres eliminar esta Tag?",
          deleteMessage: "Esta acción no se puede revertir."
        },
        table: {
          id: "ID",
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros de Etiquetas",
          contacts: "contactos",
          contact: "contacto",
          actions: "Acciones"
        },
        kpis: {
          total: "Total de tags",
          totalContacts: "Contactos etiquetados",
          withContacts: "Tags en uso"
        },
        tooltips: {
          edit: "Editar",
          delete: "Eliminar",
          viewContacts: "Ver contactos"
        },
        buttons: {
          add: "Nueva Tag"
        },
        toasts: {
          deleted: "Tag eliminada con éxito."
        }
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "En abierto",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que quieres eliminar esta Lane?",
          deleteMessage: "Esta acción no se puede revertir."
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Lane",
          backToKanban: "Volver al Kanban"
        },
        toasts: {
          deleted: "Lane eliminada con éxito."
        }
      },
      files: {
        title: "Lista de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción"
        },
        toasts: {
          deleted: "¡Lista eliminada con éxito!",
          deletedAll: "¡Todas las listas fueron eliminadas con éxito!"
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Eliminar Todos"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          deleteMessage: "¿Estás seguro de que deseas eliminar esta lista?",
          deleteAllMessage: "¿Estás seguro de que deseas eliminar todas las listas?"
        }
      },
      settings: {
        success: "Configuraciones guardadas con éxito.",
        currency: "Moneda",
        title: "Configuraciones",
        tabs: {
          options: "General",
          schedules: "Horarios",
          companies: "Empresas",
          plans: "Planes",
          helps: "Ayuda",
          whitelabel: "Whitelabel",
          timezone: "Zona Horaria",
          smtp: "Email / SMTP",
          meta: "Meta"
        },
        helps: {
          systemCurrency: {
            description: "Define la moneda mostrada en los cards del Kanban y en todos los campos de valor del sistema.",
            steps: [
              "Seleccione la moneda en el menú desplegable.",
              "El cambio se sincroniza en tiempo real para todos los usuarios.",
              "Afecta los cards del Kanban, campañas y reportes financieros.",
            ],
          },
          userCreation: {
            description: "Permite que nuevos usuarios se registren en la plataforma.",
            steps: [
              "Active para permitir el registro público en /signup.",
              "Desactive para mantener control total del acceso.",
            ],
          },
          userRating: {
            description: "Solicita una valoración del cliente al cerrar el ticket.",
            steps: [
              "Active para enviar encuesta de satisfacción al finalizar.",
              "El cliente puntúa de 1 a 5.",
              "Los datos aparecen en los reportes de calidad.",
            ],
          },
          officeScheduling: {
            description: "Define de dónde el sistema leerá los horarios de atención.",
            steps: [
              "Deshabilitado: el sistema no bloquea atención por horario.",
              "Cola: usa los horarios configurados en cada cola.",
              "Empresa: usa el horario general de la empresa.",
              "Conexión: usa el horario configurado en cada conexión de WhatsApp.",
            ],
          },
          sendGreetingAccepted: {
            description: "Envía un mensaje al cliente cuando el agente acepta el ticket.",
            steps: [
              "Active para iniciar con un saludo automático.",
              "Personalice el texto en el campo que aparece abajo.",
              "El cliente lo recibe al hacer clic en Aceptar.",
            ],
          },
          userRandom: {
            description: "Distribuye los tickets aleatoriamente entre los agentes en línea.",
            steps: [
              "Active para balancear la carga de trabajo.",
              "Solo agentes en línea reciben tickets.",
            ],
          },
          sendMsgTransfTicket: {
            description: "Envía mensaje al cliente cuando el ticket se transfiere de cola.",
            steps: [
              "Active para informar la transferencia al cliente.",
              "Use ${queue.name} para incluir el nombre de la nueva cola.",
              "Personalice el mensaje en el campo de abajo.",
            ],
          },
          acceptCallWhatsapp: {
            description: "Define si WhatsApp acepta llamadas de voz/video de los clientes.",
            steps: [
              "Desactive para enviar mensaje automático cuando el cliente llame.",
              "Configure el mensaje en el campo de abajo.",
              "Útil cuando su equipo no atiende llamadas.",
            ],
          },
          sendSignMessage: {
            description: "Permite al agente enviar su firma con los mensajes.",
            steps: [
              "Active para mostrar el botón de firma en el chat.",
              "Cada agente define su firma en el perfil.",
            ],
          },
          sendGreetingMessageOneQueues: {
            description: "Envía saludo aunque haya solo una cola configurada.",
            steps: [
              "Por defecto, con 1 cola se omite el saludo.",
              "Active para enviar siempre el saludo configurado.",
            ],
          },
          sendQueuePosition: {
            description: "Informa al cliente su posición actual en la cola.",
            steps: [
              "Active para dar transparencia sobre la espera.",
              "Use ${pos} para incluir la posición en el mensaje.",
              "Personalice el texto en el campo de abajo.",
            ],
          },
          sendFarewellWaitingTicket: {
            description: "Envía mensaje de despedida cuando el ticket queda en espera.",
            steps: [
              "Active para informar al cliente sobre el tiempo de espera.",
              "El mensaje se configura por cola.",
            ],
          },
          acceptAudioMessageContact: {
            description: "Define si el sistema acepta audios enviados por el cliente.",
            steps: [
              "Desactive para bloquear la recepción de audios.",
              "Texto y otros medios siguen funcionando.",
            ],
          },
          enableLGPD: {
            description: "Habilita controles de protección de datos (RGPD).",
            steps: [
              "Active para mostrar avisos de privacidad al cliente.",
              "Configure el mensaje de bienvenida y el enlace de la política.",
              "Use las opciones de abajo para ofuscar datos sensibles.",
            ],
          },
          requiredTag: {
            description: "Exige al menos una etiqueta en el ticket antes de cerrar.",
            steps: [
              "Active para garantizar la categorización.",
              "Los agentes no podrán cerrar tickets sin etiqueta.",
              "Gestione las etiquetas en \"Etiquetas\" del menú lateral.",
            ],
          },
          closeTicketOnTransfer: {
            description: "Cierra el ticket actual al transferir a otro sector.",
            steps: [
              "Active para crear un nuevo ticket en el sector destino.",
              "El historial se conserva en ambos tickets.",
              "Útil para separar la atención por departamento.",
            ],
          },
          showNotificationPending: {
            description: "Muestra notificación visual de tickets pendientes.",
            steps: [
              "Active para alertar sobre tickets en espera.",
              "Las notificaciones aparecen en la esquina superior derecha.",
            ],
          },
          autoTranslate: {
            description: "Traduce automáticamente los mensajes usando IA.",
            steps: [
              "Active y pegue su API Key de OpenAI en el campo de abajo.",
              "Los mensajes se traducen al idioma del agente.",
              "OpenAI factura por tokens consumidos.",
            ],
          },
          aiAutoSummary: {
            description: "Genera resúmenes diarios automáticos con IA.",
            steps: [
              "Active para recibir un resumen del día.",
              "Defina el horario en que se generará.",
              "Cubre todos los tickets abiertos del día.",
            ],
          },
          sendWelcomeMessage: {
            description: "Envía mensaje de bienvenida al registrar una nueva empresa.",
            steps: [
              "Active para automatizar el onboarding.",
              "Personalice el template con variables como {name}, {companyName}.",
              "Variables disponibles: {email}, {phone}, {trialDate}.",
            ],
          },
          flowbuilderAI: {
            description: "Habilita la \"Salida IA\" en los bloques del FlowBuilder.",
            steps: [
              "Active para usar IA cuando expira el tiempo de respuesta.",
              "Pegue su API Key de OpenAI en el campo de abajo.",
              "La IA lee el historial y asume la conversación.",
            ],
          },
          greetingAcceptedMessage: {
            description: "Texto enviado automáticamente cuando un agente acepta el ticket.",
            steps: [
              "Escriba un saludo corto y humano.",
              "Úselo para avisar que la atención comenzó.",
              "Evite prometer un plazo si su operación no puede garantizarlo.",
            ],
          },
          transferMessage: {
            description: "Texto enviado cuando el ticket se transfiere a otra cola.",
            steps: [
              "Explique que la atención fue enviada a otro sector.",
              "Use ${queue.name} para mostrar el nombre de la nueva cola.",
              "Mantenga el mensaje claro para que el cliente no piense que fue abandonado.",
            ],
          },
          AcceptCallWhatsappMessage: {
            description: "Texto enviado cuando el cliente intenta llamar por WhatsApp y las llamadas no son aceptadas.",
            steps: [
              "Explique que la atención se realiza por mensaje.",
              "Oriente al cliente a escribir la solicitud en el chat.",
              "Use un tono educado para reducir frustración.",
            ],
          },
          sendQueuePositionMessage: {
            description: "Texto que informa al cliente su posición actual en la cola.",
            steps: [
              "Use ${pos} para insertar la posición actual automáticamente.",
              "Informe que debe esperar la atención.",
              "Evite tiempos exactos si la cola cambia mucho.",
            ],
          },
          lgpdMessage: {
            description: "Mensaje de aviso de privacidad enviado al contacto.",
            steps: [
              "Explique de forma simple que los datos se usarán durante la atención.",
              "Incluya orientación para aceptar o continuar.",
              "Use un texto alineado con su política de privacidad.",
            ],
          },
          lgpdDeleteMessage: {
            description: "Ofusca el contenido de los mensajes eliminados por el contacto.",
            steps: [
              "Active para ocultar mensajes eliminados por el cliente.",
              "Desactive para mantener el contenido original visible.",
              "Recomendado para cumplir con RGPD.",
            ],
          },
          lgpdConsent: {
            description: "Solicita consentimiento explícito del contacto para recolectar datos.",
            steps: [
              "Active para enviar el aviso de consentimiento al primer contacto.",
              "El cliente debe aceptar para continuar.",
              "Requerido en flujos sensibles por RGPD.",
            ],
          },
          lgpdHideNumber: {
            description: "Ofusca el teléfono del contacto para otros usuarios.",
            steps: [
              "Active para ocultar el número a agentes no autorizados.",
              "Solo administradores ven el número completo.",
              "Recomendado para cumplir con privacidad.",
            ],
          },
        },
        smtp: {
          title: "Configuración de correo (SMTP)",
          subtitle: "Configure el servidor SMTP para el envío de correos de recuperación de contraseña y notificaciones.",
          preset: "Proveedor de correo",
          presetCustom: "Personalizado",
          host: "Servidor SMTP",
          port: "Puerto",
          user: "Usuario / Correo",
          userPlaceholder: "tu-correo@tudominio.com",
          password: "Contraseña",
          from: "Correo del remitente",
          fromHelper: "Si está vacío, se usará el correo del usuario SMTP",
          fromPlaceholder: "noreply@tudominio.com",
          secure: "Seguridad",
          secureSslOption: "SSL/TLS (puerto 465)",
          secureStarttlsOption: "STARTTLS (puerto 587)",
          sendgridUserLabel: "Usuario (fijo: apikey)",
          sendgridUserHelper: "SendGrid usa 'apikey' como usuario fijo",
          sendgridPasswordLabel: "API Key",
          sendgridFromHelper: "Obligatorio: use un remitente verificado en SendGrid",
          save: "Guardar configuración",
          testConnection: "Probar conexión",
          sendTestTitle: "Enviar correo de prueba",
          sendTestSubtitle: "Envíe un correo de prueba para confirmar que la configuración SMTP funciona correctamente.",
          testEmailLabel: "Correo de destino",
          testEmailPlaceholder: "prueba@correo.com",
          sendTest: "Enviar prueba",
          fillRequired: "Complete Host, Usuario y Contraseña.",
          fillTestEmail: "Complete el correo de destino.",
          saveSuccess: "¡Configuración SMTP guardada con éxito!",
          saveError: "Error al guardar la configuración SMTP.",
          testError: "Error al probar la conexión SMTP.",
          sendTestError: "Error al enviar el correo de prueba.",
          fieldHelps: {
            preset: "Elija su proveedor de correo. Si aparece en la lista, el sistema completa servidor, puerto y seguridad automáticamente. Use Personalizado cuando su proveedor no esté en la lista.",
            host: "Pegue la dirección del servidor SMTP informada por su proveedor de correo. Ejemplos: smtp.hostinger.com, smtp.gmail.com, smtp.sendgrid.net.",
            port: "Ingrese el puerto indicado por su proveedor. En la mayoría de los casos use 465 con SSL/TLS o 587 con STARTTLS.",
            user: "Informe el usuario de la cuenta de correo que enviará los mensajes. Normalmente es el correo completo, como contacto@tudominio.com.",
            password: "Ingrese la contraseña SMTP de la cuenta. En Gmail, Outlook y otros proveedores con verificación en dos pasos, normalmente necesita una contraseña de aplicación, no la contraseña normal.",
            sendgridPassword: "Pegue la API Key creada en SendGrid. No use la contraseña de su cuenta SendGrid.",
            from: "Correo que aparecerá como remitente para quien reciba el mensaje. Si lo deja vacío, el sistema usa el Usuario / Correo de arriba.",
            secure: "Elija el tipo de seguridad que coincide con el puerto. El puerto 465 suele usar SSL/TLS. El puerto 587 suele usar STARTTLS.",
            testEmail: "Ingrese su correo o el de alguien del equipo para recibir la prueba. Así confirma si el envío funciona.",
          },
          helps: {
            serverConfig: {
              description: "Configura el servidor SMTP usado para enviar correos del sistema (recuperación de contraseña, notificaciones, invitaciones).",
              steps: [
                "Elija un proveedor preconfigurado (Hostinger, Gmail, SendGrid, Outlook) o \"Personalizado\".",
                "Complete Servidor, Puerto, Usuario (correo de la cuenta) y Contraseña (o contraseña de aplicación).",
                "Seleccione SSL/TLS (puerto 465) o STARTTLS (puerto 587) según su proveedor.",
                "Haga clic en \"Probar Conexión\" para validar antes de guardar.",
                "Guarde la configuración.",
              ],
            },
            sendTest: {
              description: "Envía un correo de prueba con la configuración SMTP de arriba para validar el flujo completo.",
              steps: [
                "Guarde la configuración SMTP primero.",
                "Ingrese un correo de destino válido.",
                "Haga clic en \"Enviar Prueba\" — el correo llega en segundos.",
                "Verifique la bandeja de entrada (y la carpeta de spam) para confirmar.",
              ],
            },
          },
        },
        meta: {
          copy: "Copiar",
          copied: "¡Copiado!",
          credentials: {
            title: "Credenciales de la App de Meta",
            description: "Conecte su App creada en Meta for Developers para integrar Facebook Messenger e Instagram Direct.",
            appIdLabel: "Facebook App ID",
            appIdPlaceholder: "Ej.: 123456789012345",
            appIdHelper: "Encuentre en developers.facebook.com › App › Configuración › Básico.",
            appSecretLabel: "Facebook App Secret",
            appSecretPlaceholder: "Ej.: abc123def456...",
            appSecretHelper: "Clave secreta de la App. Nunca la comparta ni la suba al repositorio.",
          },
          webhook: {
            title: "Configuración del Webhook",
            description: "Use estos valores al registrar el webhook en el panel de Meta para que los mensajes lleguen al sistema.",
            verifyTokenLabel: "Token de Verificación",
            verifyTokenHelper: "Generado automáticamente. Péguelo en el campo \"Token de verificación\" del webhook en Meta.",
            callbackUrlLabel: "URL de Callback",
            callbackUrlHelper: "Pegue en el campo \"URL de callback\" del webhook en Meta for Developers.",
          },
          fieldHelps: {
            wabaFacebookAppId: "ID numérico de la App Meta usada en el registro incorporado de WhatsApp API Oficial.",
            wabaFacebookAppSecret: "Clave secreta de la App Meta usada para WhatsApp API Oficial. Nunca comparta este valor.",
            wabaFacebookConfigId: "ID de configuración de Facebook Login for Business usado para abrir el registro incorporado de WhatsApp.",
            wabaWhatsappBusinessToken: "Token permanente del usuario del sistema con permisos para administrar y enviar mensajes por WhatsApp Cloud API.",
            socialFacebookAppId: "ID numérico de la App Meta usada para Facebook Messenger e Instagram Direct.",
            socialFacebookAppSecret: "Clave secreta de la App Meta usada para Facebook Messenger e Instagram Direct. Nunca comparta este valor.",
            facebookVerifyToken: "Token generado por el sistema para que Meta confirme que el webhook pertenece a esta instalación.",
            webhookUrl: "URL que debe registrarse en el webhook de la App Meta de Facebook/Instagram.",
            wabaWebhookUrl: "URL que debe registrarse en el webhook del producto WhatsApp de la App Meta.",
            wabaVerifyToken: "Token generado por el sistema para validar el webhook del producto WhatsApp en Meta.",
          },
          helps: {
            credentials: {
              description: "Credenciales de su App en Meta for Developers — necesarias para que los mensajes de Messenger e Instagram lleguen a la plataforma.",
              steps: [
                "Acceda a developers.facebook.com y cree una App tipo \"Empresa\".",
                "En la App, abra Configuración › Básico — copie App ID y App Secret.",
                "Pegue los valores aquí — se guardan automáticamente al salir del campo.",
                "Agregue los productos \"Messenger\" e \"Instagram Graph API\" a la App.",
              ],
            },
            webhook: {
              description: "Webhook que Meta usa para enviar los mensajes de sus canales al sistema.",
              steps: [
                "En la App de Meta, abra Messenger › Configuración › Webhooks (lo mismo para Instagram).",
                "Haga clic en \"Agregar URL de callback\".",
                "Copie la URL de Callback de aquí y péguela en el campo correspondiente.",
                "Copie el Token de Verificación de aquí y péguelo en el campo \"Token\" de Meta.",
                "Confirme — Meta validará el webhook automáticamente.",
              ],
            },
          },
        },
        settingsConfig: {
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Activado",
              disabled: "Desactivado"
            }
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda"
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            systemCurrency: "Moneda del sistema",
            currencyUpdated: "Moneda actualizada con éxito",
            currencyHelper: "Define la moneda mostrada en los cards del Kanban y en todos los campos de valor del sistema. El cambio se sincroniza en tiempo real para todos los usuarios de la empresa.",
            creationCompanyUser: "Creación de Company/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario de Trabajo",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket: "Enviar mensaje transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar Mensajes de Grupos",
            chatBotType: "Tipo del Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp: "Informar que no acepta llamadas en whatsapp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR Firma",
            sendGreetingMessageOneQueues: "Enviar saludo cuando haya solamente 1 cola",
            sendQueuePosition: "Enviar mensaje con la posición de la cola",
            sendFarewellWaitingTicket: "Enviar mensaje de despedida en Espera",
            acceptAudioMessageContact: "¿Aceptar recibir audio de todos los contactos?",
            enableLGPD: "Habilitar tratamiento RGPD",
            requiredTag: "Tag obligatoria para cerrar ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir para otra cola",
            DirectTicketsToWallets: "Mover automáticamente cliente para cartera",
            showNotificationPending: "Mostrar notificación para tickets pendientes",
            autoTranslate: "Traducción Automática de Mensajes",
            translateApiKey: "API Key OpenAI (para traducción)",
            translateApiKeyHelper: "Clave de la API OpenAI para traducción automática. Si está vacío, usa la clave del primer Prompt configurado.",
            aiAutoSummary: "Resumen IA diario automático",
            aiSummaryApiKey: "API Key OpenAI (para resumen IA)",
            aiSummaryApiKeyHelper: "Clave usada solo para resúmenes IA. Si está vacío, usa la clave de traducción o la clave del primer Prompt configurado.",
            aiAutoSummaryTime: "Horario del resumen IA diario",
            aiAutoSummaryTimeHelper: "Horario en que se generará el resumen automático para todos los tickets abiertos.",
            flowbuilderAISectionTitle: "Salida IA de FlowBuilder",
            flowbuilderAISectionDescription: "Cuando está activado, la \"Salida IA\" en los bloques de FlowBuilder usa GPT para leer el historial de la conversación y asumir automáticamente la atención cuando expira el tiempo.",
            flowbuilderAI: "Activar Salida IA en FlowBuilder",
            flowbuilderAIApiKey: "API Key OpenAI (Salida IA)",
            flowbuilderAIApiKeyHelper: "Clave de la API OpenAI usada por la Salida IA de los bloques de FlowBuilder.",
            sendWelcomeMessage: "Mensaje de bienvenida al registrarse",
            welcomeMessageTemplate: "Modelo del mensaje de bienvenida",
            welcomeMessageHelper: "Use variables: {name}, {companyName}, {email}, {phone}, {trialDate}. Si está vacío, usa el modelo predeterminado.",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la cola",
            AcceptCallWhatsappMessage: "Mensaje para informar que no acepta llamadas",
            greetingAcceptedMessage: "Mensaje de Saludo al aceptar ticket",
            transferMessage: "Mensaje de transferencia - ${queue.name} = cola destino"
          },
          LGPD: {
            title: "RGPD",
            welcome: "Mensaje de bienvenida (RGPD)",
            linkLGPD: "Enlace de la política de privacidad",
            obfuscateMessageDelete: "Ocultar mensaje eliminado",
            alwaysConsent: "Siempre solicitar consentimiento",
            obfuscatePhoneUser: "Ocultar número de teléfono para usuarios",
            enabled: "Habilitado",
            disabled: "Deshabilitado"
          },
        },
        toasts: {
          schedulesSavedSuccess: "Horarios actualizados con éxito.",
          operationUpdatedSuccess: "Operación actualizada con éxito.",
          recordsLoadError: "No se pudo cargar la lista de registros",
          operationSuccess: "¡Operación realizada con éxito!",
          operationError: "No se pudo realizar la operación. Verifique si ya existe un registro con el mismo nombre o si todos los campos están completados correctamente",
          operationDeleteError: "No se pudo realizar la operación",
          imageUploadProgress: "La imagen está {{progress}}% subida...",
          imageUploadError: "Hubo un problema al subir la imagen.",
          companyOperationError: "No se pudo realizar la operación. Verifique si ya existe una empresa con el mismo nombre o si todos los campos están completados correctamente",
          planOperationError: "No se pudo realizar la operación. Verifique si ya existe un plan con el mismo nombre o si todos los campos están completados correctamente",
          helpOperationError: "No se pudo realizar la operación. Verifique si ya existe una ayuda con el mismo nombre o si todos los campos están completados correctamente",
        },
        whitelabel: {
          subtitle: "Personaliza la marca del sistema — colores, nombre, logos y favicon — mostrados en toda la aplicación.",
          primaryColorLight: "Color Primario Modo Claro",
          primaryColorDark: "Color Primario Modo Oscuro",
          sidebarTextColorLight: "Color de textos e íconos del sidebar en modo claro",
          sidebarTextColorDark: "Color de textos e íconos del sidebar en modo oscuro",
          systemName: "Nombre del Sistema",
          systemNamePlaceholder: "Ej: ChatIA",
          lightLogo: "Logo Claro",
          darkLogo: "Logo Oscuro",
          sidebarLightLogo: "Logo del sidebar en modo claro",
          sidebarDarkLogo: "Logo del sidebar en modo oscuro",
          loginLightLogo: "Logo del login en modo claro",
          loginDarkLogo: "Logo del login en modo oscuro",
          sidebarIconLight: "Ícono del sidebar cerrado en modo claro",
          sidebarIconDark: "Ícono del sidebar cerrado en modo oscuro",
          favicon: "Favicon",
          sections: {
            identity: "Identidad Visual",
            identitySubtitle: "Define los colores y el nombre mostrados al usuario.",
            logos: "Logos del Sistema",
            logosSubtitle: "Imágenes usadas en el login, sidebar y pestañas del navegador.",
          },
          actions: {
            upload: "Subir imagen",
            replace: "Reemplazar",
            remove: "Eliminar",
            pickColor: "Elegir color",
          },
          languages: {
            title: "Idiomas",
            subtitle: "Define el idioma predeterminado de la empresa y qué idiomas pueden elegir los usuarios.",
            defaultLabel: "Idioma predeterminado",
            availableLabel: "Idiomas disponibles",
            defaultBadge: "Predeterminado",
            selectedCount_one: "{{count}} idioma seleccionado",
            selectedCount_other: "{{count}} idiomas seleccionados",
          },
          whatsappButton: {
            title: "Botón de WhatsApp",
            subtitle: "Controla el botón de contacto mostrado en el registro y en modo trial.",
            enabledLabel: "Mostrar botones",
            enabledTitle: "Botones activos",
            enabledHint: "Cuando está desactivado, elimina el botón de las pantallas públicas y del trial.",
            phoneLabel: "Teléfono de WhatsApp",
          },
          previews: {
            light: "Vista previa (modo claro)",
            dark: "Vista previa (modo oscuro)",
            loginLight: "Vista previa del login (modo claro)",
            loginDark: "Vista previa del login (modo oscuro)",
            sidebarIconLight: "Vista previa del ícono del sidebar (modo claro)",
            sidebarIconDark: "Vista previa del ícono del sidebar (modo oscuro)",
            favicon: "Vista previa (favicon)",
            empty: "No se subió ninguna imagen — se usa el predeterminado del sistema.",
          },
          helps: {
            primaryColorLight: {
              description: "Color de acento usado cuando el sistema está en tema claro (botones, enlaces, íconos primarios).",
              steps: [
                "Haz clic en el campo para abrir el selector de color.",
                "Usa colores con buen contraste sobre fondo blanco (suficientemente oscuros para texto legible).",
                "El cambio se aplica inmediatamente para todos los usuarios.",
                "Pega un HEX válido (ej: #1976d2) si ya tienes el color de la marca.",
              ],
            },
            primaryColorDark: {
              description: "Color de acento usado cuando el sistema está en tema oscuro.",
              steps: [
                "Haz clic en el campo para abrir el selector de color.",
                "Prefiere colores claros para contrastar con fondos oscuros.",
                "No tiene que ser igual al del modo claro — adapta para legibilidad.",
                "Pega un HEX válido (ej: #4fc3f7) si quieres saltarte el selector.",
              ],
            },
            sidebarTextColorLight: {
              description: "Color único aplicado a textos e íconos del menú lateral cuando el sistema está en modo claro.",
              steps: [
                "Haz clic en el campo para abrir el selector de color.",
                "Usa un color con buen contraste sobre el color primario claro del sidebar.",
                "El cambio se aplica inmediatamente en el menú lateral.",
                "Afecta textos, íconos, divisores y botón de contraer del sidebar en modo claro.",
              ],
            },
            sidebarTextColorDark: {
              description: "Color único aplicado a textos e íconos del menú lateral cuando el sistema está en modo oscuro.",
              steps: [
                "Haz clic en el campo para abrir el selector de color.",
                "Usa un color con buen contraste sobre el color primario oscuro del sidebar.",
                "El cambio se aplica inmediatamente en el menú lateral.",
                "Afecta textos, íconos, divisores y botón de contraer del sidebar en modo oscuro.",
              ],
            },
            systemName: {
              description: "Nombre del producto mostrado en varios lugares (título de la pestaña, e-mails, login, sidebar).",
              steps: [
                "Usa el nombre comercial — máximo ~20 caracteres recomendado.",
                "Se guarda automáticamente al salir del campo.",
                "Aparece en el <title> de la página (pestaña del navegador).",
                "Déjalo vacío para usar \"Multi100\" como predeterminado.",
              ],
            },
            lightLogo: {
              description: "Logo mostrado en la parte superior del sidebar cuando el sistema está en tema claro.",
              steps: [
                "Usa PNG o SVG con fondo transparente.",
                "Resolución recomendada: hasta 400×120 px.",
                "Este logo no cambia la pantalla de login.",
                "Haz clic en el ícono de eliminar para volver al logo predeterminado.",
              ],
            },
            darkLogo: {
              description: "Logo mostrado en la parte superior del sidebar cuando el sistema está en tema oscuro.",
              steps: [
                "Usa una versión clara del logo, con buen contraste sobre fondo oscuro.",
                "PNG o SVG con fondo transparente.",
                "Resolución recomendada: hasta 400×120 px.",
                "Este logo no cambia la pantalla de login.",
              ],
            },
            loginLightLogo: {
              description: "Logo mostrado en las pantallas de login, registro y recuperación de contraseña en modo claro.",
              steps: [
                "Usa una versión optimizada para fondos claros.",
                "Este logo es independiente del logo del sidebar.",
                "Si está vacío, el sistema usa el logo claro del sidebar como fallback.",
              ],
            },
            loginDarkLogo: {
              description: "Logo mostrado en las pantallas de login, registro y recuperación de contraseña en modo oscuro.",
              steps: [
                "Usa una versión optimizada para fondos oscuros.",
                "Este logo es independiente del logo del sidebar.",
                "Si está vacío, el sistema usa el logo oscuro del sidebar como fallback.",
              ],
            },
            sidebarIconLight: {
              description: "Ícono mostrado cuando el sidebar está cerrado en modo claro.",
              steps: [
                "Usa una imagen cuadrada, preferiblemente PNG o SVG.",
                "Al pasar el mouse por encima, el ícono se cambia por el botón para abrir el sidebar.",
                "Si está vacío, el sistema usa el favicon como fallback.",
              ],
            },
            sidebarIconDark: {
              description: "Ícono mostrado cuando el sidebar está cerrado en modo oscuro.",
              steps: [
                "Usa una versión con buen contraste para fondos oscuros.",
                "Cuando el mouse sale, el botón vuelve a ser el ícono.",
                "Si está vacío, el sistema usa el favicon como fallback.",
              ],
            },
            favicon: {
              description: "Ícono mostrado en la pestaña del navegador y accesos directos.",
              steps: [
                "Usa PNG o ICO cuadrado (32×32, 48×48 o 64×64 px).",
                "Mantén un diseño simple — queda muy pequeño en la pestaña.",
                "Puede tardar unos minutos en actualizar el navegador (caché).",
                "Fuerza la actualización con Ctrl+F5 si no ves el cambio.",
              ],
            },
            defaultLanguage: {
              description: "Idioma mostrado en las pantallas públicas (login/registro) y usado como predeterminado para todos los usuarios de la empresa que aún no eligieron un idioma manualmente.",
              steps: [
                "Selecciona el idioma predeterminado en el menú desplegable.",
                "Al cambiarlo, los usuarios que aún usaban el idioma predeterminado anterior serán migrados automáticamente al nuevo.",
                "Los usuarios que eligieron un idioma manualmente en el selector superior NO se ven afectados.",
                "El idioma predeterminado siempre queda disponible.",
              ],
            },
            availableLanguages: {
              description: "Idiomas que los usuarios pueden seleccionar en el botón de bandera arriba.",
              steps: [
                "Marca los idiomas que quieres habilitar para tu equipo.",
                "Desmarcar un idioma lo quita inmediatamente del selector de todos los usuarios conectados.",
                "El idioma predeterminado siempre permanece disponible (no se puede desmarcar).",
                "Los cambios se reflejan en tiempo real, sin necesidad de recargar.",
              ],
            },
          },
        },
        chatBotType: {
          text: "Texto",
        },
        modals: {
          deleteTitle: "Eliminar Registro",
          deleteConfirmation: "¿Realmente desea eliminar este registro?",
        },
        managers: {
          common: {
            yes: "Sí",
            no: "No",
          },
          companies: {
            recurrence: "Recurrencia",
          },
          plans: {
            queues: "Colas",
            value: "Valor",
            whatsapp: "WhatsApp",
            facebook: "Facebook",
            instagram: "Instagram",
            internalChat: "Chat Interno",
            externalAPI: "API Externa",
            kanban: "Kanban",
            talkAI: "Prompts",
            officialAPI: "API Oficial",
            integrations: "Integraciones",
          },
          helps: {
            title: "Título",
            video: "Video",
          },
        },
        timezone: {
          companyTimezone: {
            title: "Zona Horaria de la Empresa",
            selectLabel: "Seleccionar zona horaria",
            customHelperText: "Zona horaria personalizada para esta empresa",
            inheritedHelperText: "Usando la zona horaria por defecto del sistema",
          },
          defaultTimezone: {
            title: "Zona Horaria Por Defecto del Sistema",
            selectLabel: "Seleccionar zona horaria por defecto",
            helperText: "Esta zona horaria se utilizará por defecto para todas las empresas que no tengan una zona horaria personalizada",
          },
          buttons: {
            save: "Guardar",
            useDefault: "Usar Por Defecto",
            saveDefault: "Guardar Por Defecto",
          },
          preview: {
            currentTime: "Hora Actual",
            defaultTime: "Hora Por Defecto",
          },
          status: {
            custom: "Personalizado",
            inherited: "Heredado",
          },
          errors: {
            fetchAvailableTimezones: "Error al cargar las zonas horarias disponibles",
            fetchCompanyTimezone: "Error al cargar la zona horaria de la empresa",
            updateDefaultTimezone: "Error al actualizar la zona horaria por defecto",
            updateCompanyTimezone: "Error al actualizar la zona horaria de la empresa",
          },
          success: {
            defaultTimezoneUpdated: "Zona horaria por defecto actualizada con éxito",
            companyTimezoneUpdated: "Zona horaria de la empresa actualizada con éxito",
            companyTimezoneReset: "Zona horaria de la empresa restablecida con éxito",
          },
          helps: {
            companyTimezone: {
              description: "Define la zona horaria usada en todas las fechas y horas de la empresa (notificaciones, agendamientos, reportes, horario de atención).",
              steps: [
                "Seleccione la zona horaria deseada en el menú desplegable.",
                "Haga clic en \"Guardar\" para aplicar — afecta a toda la empresa.",
                "Haga clic en \"Usar Por Defecto\" para volver a la zona configurada por el super admin.",
                "La vista previa de la derecha muestra la hora actual en la zona seleccionada.",
              ],
            },
            defaultTimezone: {
              description: "Zona horaria usada por defecto para todas las empresas que aún no definieron una propia.",
              steps: [
                "Defina aquí la zona horaria global del sistema.",
                "Las empresas sin zona personalizada heredan este valor.",
                "Los cambios aquí solo afectan a las empresas que no personalizaron su propia zona.",
                "Solo super administradores pueden cambiar este campo.",
              ],
            },
            companyTimezoneField: {
              description: "Campo donde elige la zona horaria de esta empresa.",
              steps: [
                "Busque por país, ciudad o nombre de la zona horaria.",
                "Elija la zona donde opera la empresa.",
                "Guarde para aplicarla en agendamientos, reportes y horarios de atención.",
              ],
            },
            defaultTimezoneField: {
              description: "Campo donde el super admin elige la zona horaria por defecto del sistema.",
              steps: [
                "Use la zona de la mayoría de las empresas atendidas.",
                "Las empresas sin zona propia usarán este valor automáticamente.",
                "Guarde para aplicarla como valor global.",
              ],
            },
          },
        }
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle: "¿Desea dejar una evaluación de atención para el cliente?",
          dialogClosingTitle: "¡Finalizando la atención con el cliente!",
          dialogRatingCancel: "Resolver CON Mensaje de Despedida",
          dialogRatingSuccess: "Resolver y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Resolver SIN Mensaje de Despedida",
          ratingTitle: "Elige un menú de evaluación",
          notMessage: "Ningún mensaje seleccionado",
          amount: "Valor de prospección",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Habilitar integración",
            disableIntegration: "Deshabilitar integración",
            logTicket: "Logs del Ticket",
            requiredTag: "Debes asignar una etiqueta antes de cerrar el ticket.",
            enableTranslate: "Activar traducción automática para este contacto",
            disableTranslate: "Desactivar traducción automática para este contacto",
            translateEnabled: "Traducción activada",
            translateDisabled: "Traducción desactivada",
            kanban: "Kanban",
            tags: "Etiquetas",
            aiSummaries: "Resúmenes IA",
            options: "Opciones",
            chatbotActive: "Chatbot activo",
            chatbotInactive: "Chatbot inactivo",
            enableChatbot: "Activar Chatbot",
            disableChatbot: "Desactivar Chatbot",
          }
        }
      },
      messagesInput: {
        placeholderPrivateMessage: "Escribe un mensaje o aprieta / para respuestas rápidas",
        placeholderOpen: "Escribe un mensaje o aprieta / para respuestas rápidas",
        placeholderClosed: "Reabra o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privado",
        translateTooltip: "Su mensaje será traducido a",
        you: "Tú",
        contact: "Contacto",
        videoFallback: "Vídeo",
        format: {
          bold: "Negrita",
          italic: "Cursiva",
          strikethrough: "Tachado",
          code: "Código",
          numberedList: "Lista numerada",
          bulletList: "Lista con viñetas",
          quote: "Cita",
        },
        aiSuggestion: {
          tooltip: "Sugerencia IA",
          configTitle: "Configurar Sugerencias IA",
          promptLabel: "Prompt personalizado",
          promptPlaceholder: "Ej.: Eres un agente de ventas especializado en software. Siempre sugiere agendar una demostración...",
          promptHelper: "Instruye a la IA sobre cómo generar sugerencias. Ej.: perfil del agente, tono, productos, reglas de negocio.",
          save: "Guardar",
          saving: "Guardando...",
        },
        quickReplies: {
          header: "Respuestas rápidas",
          searchPlaceholder: "Buscar por atajo o mensaje...",
          empty: "No se encontró ninguna respuesta",
          useReply: "Usar respuesta",
        },
      },
      contactDrawer: {
        header: "Datos del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
          blockContact: "Bloquear contacto",
          unblockContact: "Desbloquear contacto",
        },
        tabs: {
          data: "Datos",
          followUp: "Follow-up",
          favorites: "Favoritos",
        },
        none: "Ninguno",
        noFavoriteMessages: "Ningún mensaje favorito",
        qualification: "Calificación",
        toasts: {
          contactBlocked: "Contacto bloqueado",
          contactUnblocked: "Contacto desbloqueado",
        },
        confirmationModal: {
          blockMessage: "¿Realmente quieres bloquear este contacto? Ya no recibirás mensajes de él.",
          unblockMessage: "¿Realmente quieres desbloquear este contacto? Podrás comenzar a recibir mensajes de él.",
        },
        extraInfo: "Otras informaciones"
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          email: "E-mail",
          user: "Agente",
          greeting: "Saludo",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº de Ticket",
          queue: "Cola",
          connection: "Conexión"
        },
        templates: {
          firstName: { label: "Primer nombre", description: "Primer nombre del contacto" },
          name: { label: "Nombre completo", description: "Nombre completo del contacto" },
          userName: { label: "Agente", description: "Nombre del agente" },
          ticketId: { label: "ID del Ticket", description: "Número del ticket" },
          greeting: { label: "Saludo", description: "Buenos días / Buenas tardes / Buenas noches" },
          hour: { label: "Hora", description: "Hora actual" },
          date: { label: "Fecha", description: "Fecha actual" },
          dateTime: { label: "Fecha y hora", description: "Fecha y hora actual" },
          queue: { label: "Cola", description: "Nombre de la cola del ticket" },
          connection: { label: "Conexión", description: "Nombre de la conexión WhatsApp" },
          protocol: { label: "Protocolo", description: "Número de protocolo" },
          companyName: { label: "Empresa", description: "Nombre de la empresa" },
        },
      },
      ticketOptionsMenu: {
        schedule: "Programación",
        delete: "Eliminar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Finalizar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Ticket",
          textarea: "Observación",
          placeholder: "Inserta aquí la información que deseas registrar"
        },
        confirmationModal: {
          title: "Eliminar el ticket del contacto",
          titleFrom: "del contacto ",
          message: "¡Atención! Todas las mensajes relacionadas con el ticket se perderán."
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar"
        }
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar"
        }
      },
      emoji: {
        search: "Buscar",
        notfound: "No se encontró ningún emoji",
        categories: {
          search: "Resultados",
          recent: "Recientes",
          smileys: "Caras y Emociones",
          people: "Personas",
          nature: "Animales y Naturaleza",
          foods: "Comida y Bebida",
          activity: "Actividades",
          places: "Viajes y Lugares",
          objects: "Objetos",
          symbols: "Símbolos",
          flags: "Banderas",
          custom: "Personalizados",
        },
      },
      messageInput: {
        variables: "Variables",
        aiSuggestions: "Sugerencias IA",
        selectLanguage: "Seleccione el idioma",
        placeholderCaption: "Añadir una leyenda...",
        tooltip: {
          signature: "Habilitar/Deshabilitar Firma",
          privateMessage: "Habilitar/Deshabilitar Mensaje Privada",
          meet: "Enviar link para videoconferencia",
          language: "Idioma del contacto — define a qué idioma se traducirá el mensaje",
        },
        type: {
          title: "Adjuntar",
          imageVideo: "Fotos y vídeos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Vídeo llamada"
        }
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        edit: "Editar",
        forward: "Reenviar",
        toForward: "Reenviar",
        talkTo: "Conversar con",
        react: "Reaccionar",
        favorite: "Marcar favorito",
        unfavorite: "Quitar favorito",
        copy: "Copiar",
        erase: "Borrar",
        aiGenerationFailed: "No se generó ninguna sugerencia. Verifica si la API key está configurada.",
        saveToContact: "Guardar en contacto",
        confirmationModal: {
          title: "¿Eliminar mensaje?",
          message: "Esta acción no se puede revertir."
        }
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Colas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción"
        }
      },
      userStatus: {
        online: "En línea",
        offline: "Fuera de línea",
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
        ERR_NO_DEF_WAPP_FOUND: "Ningún WhatsApp predeterminado encontrado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED: "Esta sesión de WhatsApp no fue inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT: "No fue posible verificar el contacto de WhatsApp. Verifique la página de conexiones",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA: "No fue posible descargar medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Por favor, intente nuevamente.",
        ERR_SENDING_WAPP_MSG: "Error al enviar mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No fue posible eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya existe un tíquete abierto para este contacto.",
        ERR_TICKET_ALREADY_ACCEPTED: "Este ticket ya ha sido aceptado por otro agente.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor, inicie sesión.",
        ERR_USER_CREATION_DISABLED: "La creación de usuario fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tiene permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "Ninguna configuración encontrada con este ID.",
        ERR_NO_CONTACT_FOUND: "Ningún contacto encontrado con este ID.",
        ERR_NO_TICKET_FOUND: "Ningún tíquete encontrado con este ID.",
        ERR_NO_USER_FOUND: "Ningún usuario encontrado con este ID.",
        ERR_NO_WAPP_FOUND: "Ningún WhatsApp encontrado con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear tíquete en la base de datos.",
        ERR_FETCH_WAPP_MSG: "Error al buscar el mensaje en WhatsApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Esta color ya está en uso, elija otra.",
        ERR_WAPP_GREETING_REQUIRED: "El mensaje de bienvenida es obligatorio cuando hay más de una cola.",
        ERR_OUT_OF_HOURS: "¡Fuera del Horario de Expediente!",
        ERR_USER_EMAIL_ALREADY_EXISTS: "Este email ya está en uso. Utilice otro email.",
        ERR_COMPANY_INVALID_NAME: "El nombre de la organización debe tener al menos 2 caracteres.",
        ERR_COMPANY_DUPLICATE_FIELD: "Ya existe un registro con estos datos.",
        ERR_COMPANY_CREATION_FAILED: "Error al crear la empresa. Inténtelo de nuevo.",
        ERR_GENERIC_ERROR: "¡Ocurrió un error!",
      },
      flowBuilderConfig: {
        title: "Diseña tu flujo",
        actions: {
          import: "Importar",
          export: "Exportar",
          save: "Guardar"
        },
        messages: {
          flowStart: "Inicio del flujo",
          interval: "Intervalo {{seconds}} seg.",
          intervalFormatted: "Intervalo {{value}} {{unit}}",
          businessHoursLabel: "Hor. Laboral",
          units: {
            seconds: "seg.",
            minutes: "min.",
            hours: "h",
            days: "días",
          },
          rememberSave: "¡No olvides guardar tu flujo!",
          flowSaved: "Flujo guardado con éxito"
        },
        nodes: {
          start: "Inicio",
          content: "Contenido",
          menu: "Menú",
          optionFormat: "[{{number}}] {{value}}",
          randomizer: "Aleatorizador",
          interval: "Intervalo",
          ticket: "Ticket",
          typebot: "TypeBot",
          openai: "OpenAI",
          question: "Pregunta",
          image: "Imagen",
          video: "Vídeo",
          audioNode: {
            title: "Audio",
            recordedLive: "Grabado en vivo",
            audioSent: "Audio enviado",
            browserNotSupported: "su navegador no soporta HTML5"
          },
          kanbanPhase: "Fase Kanban",
          addTag: "Agregar Etiqueta",
          noTag: "Sin etiqueta",
          noResponse: "Sin respuesta",
        },
        nodeDescriptions: {
          startFlow: "¡Este bloque marca el inicio de tu flujo!"
        },
        edges: {
          edgeWithoutOnDelete: "Edge sin onDelete configurado:",
          errorDeletingEdge: "Error al eliminar edge:",
          removeEdgeTooltip: "Eliminar conexión"
        },
        units: {
          seconds: "segundos"
        },
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          enterName: "¡Ingresa un nombre!",
          enterMessage: "¡Ingresa un mensaje!",
          required: "Obligatorio",
          describeAiTraining: "Describe el entrenamiento para Inteligencia Artificial",
          invalidModel: "Modelo inválido",
          informModel: "Informa el modelo",
          minTokens: "Mínimo 10 tokens",
          maxTokens: "Máximo 4096 tokens",
          informMaxTokens: "Informa el número máximo de tokens",
          minZero: "Mínimo 0",
          maxOne: "Máximo 1",
          informTemperature: "Informa la temperatura",
          informApiKey: "Informa la API Key",
          minOneMessage: "Mínimo 1 mensaje",
          maxFiftyMessages: "Máximo 50 mensajes",
          informMaxMessages: "Informa el número máximo de mensajes",
          informVoiceMode: "Informa el modo para Voz"
        },
        buttons: {
          add: "Agregar",
          save: "Guardar",
          edit: "Editar"
        },
        modals: {
          condition: {
            addTitle: "Agregar condición al flujo",
            editTitle: "Editar condición",
            fieldLabel: "Campo de la condición (Digite solo 1 clave)",
            validationRule: "Regla de validación",
            conditionValue: "Valor de la condición a ser analizada"
          },
          ticket: {
            addQueueError: "Agrega una cola",
            addTitle: "Agregar una cola al flujo",
            editTitle: "Editar cola",
            selectConnection: "Selecciona una cola"
          },
          randomizer: {
            addIntervalError: "Agrega el valor de intervalo",
            maxTimeError: "Máximo de tiempo alcanzado 120 segundos",
            addTitle: "Agregar un aleatorizador al flujo",
            editTitle: "Editar aleatorizador"
          },
          openai: {
            addTitle: "Agregar OpenAI/Gemini al flujo",
            editTitle: "Editar OpenAI/Gemini del flujo"
          },
          question: {
            addTitle: "Agregar Pregunta al flujo",
            editTitle: "Editar Pregunta",
            createTitle: "Crear Pregunta en el flujo",
            messageLabel: "Mensaje",
            saveAnswer: "Guardar respuesta"
          }
        },
        models: {
          "gpt-4.1": "GPT 4.1",
          "gpt-4.1-mini": "GPT 4.1 Mini",
          "gpt-4.1-nano": "GPT 4.1 Nano",
          "gpt-4o": "GPT 4o",
          "gpt-4o-mini": "GPT 4o Mini",
          "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legado)",
          "gemini-2.5-pro": "Gemini 2.5 Pro",
          "gemini-2.5-flash": "Gemini 2.5 Flash",
          "gemini-2.0-flash": "Gemini 2.0 Flash",
          "gemini-2.0-pro": "Gemini 2.0 Pro",
        },
        voice: {
          text: "Texto",
          francisca: "Francisca",
          antonio: "Antonio",
          brenda: "Brenda",
          donato: "Donato",
          elza: "Elza",
          fabio: "Fabio",
          giovanna: "Giovanna",
          humberto: "Humberto",
          julio: "Julio",
          leila: "Leila",
          leticia: "Leticia",
          manuela: "Manuela",
          nicolau: "Nicolau",
          valerio: "Valerio",
          yara: "Yara"
        }
      },
      flowBuilderModals: {
        textModal: {
          titleAdd: "Agregar mensaje al flujo",
          titleEdit: "Editar mensaje del flujo",
          buttonAdd: "Agregar",
          buttonSave: "Guardar",
          fields: {
            message: "Mensaje"
          },
          validation: {
            tooShort: "¡Muy corto!",
            tooLong: "¡Muy largo!",
            required: "¡Ingresa un nombre!",
            messageRequired: "¡Ingresa un mensaje!"
          }
        },
        intervalModal: {
          titleAdd: "Agregar un intervalo al flujo",
          titleEdit: "Editar intervalo",
          buttonAdd: "Añadir",
          buttonEdit: "Editar",
          fields: {
            interval: "Intervalo",
            timeInSeconds: "Tiempo en segundos",
            timeValue: "Tiempo",
            unit: "Unidad",
            unitSeconds: "Segundos",
            unitMinutes: "Minutos",
            unitHours: "Horas",
            unitDays: "Días",
            businessHours: "Horario laboral",
            businessHoursHelp: "El mensaje se enviará solo durante el horario laboral configurado",
            startTime: "Inicio",
            endTime: "Fin",
            daysOfWeek: "Días de la semana",
            daySun: "Dom",
            dayMon: "Lun",
            dayTue: "Mar",
            dayWed: "Mié",
            dayThu: "Jue",
            dayFri: "Vie",
            daySat: "Sáb",
          },
          validation: {
            addValue: "Agrega el valor del intervalo",
            maxTime: "Valor máximo alcanzado para esta unidad",
            maxSeconds: "Máximo de 120 segundos",
            maxMinutes: "Máximo de 120 minutos",
            maxHours: "Máximo de 72 horas",
            maxDays: "Máximo de 30 días",
          },
          aiTimeout: {
            title: "Salida IA (tiempo para que la IA asuma)",
            label: "Tiempo en segundos (0 = desactivado)",
            helperText: "Si el cliente no responde en {{seconds}}s, la IA asume la atención (salida morada)"
          }
        },
        typebotModal: {
          titleAdd: "Agregar Typebot al flujo",
          titleEdit: "Editar Typebot",
          buttonAdd: "Agregar",
          buttonEdit: "Guardar",
          fields: {
            url: "URL del Typebot",
            slug: "Slug del Bot (identificador)",
            expires: "Expiración de sesión (minutos)",
            delay: "Intervalo entre mensajes (ms)",
            keywordFinish: "Palabra para finalizar",
            keywordRestart: "Palabra para reiniciar",
            unknownMessage: "Mensaje de opción inválida",
            restartMessage: "Mensaje al reiniciar",
          },
          instructions: {
            title: "Cómo configurar Typebot (paso a paso)",
            step1: "Ten una instancia de Typebot corriendo (self-hosted o Typebot Cloud en typebot.io). Anota la URL base, ej: https://typebot.tuempresa.com",
            step2: "En el panel de Typebot, crea o abre el bot que deseas usar. El Slug es el identificador del bot en la URL — ej: si la URL del bot es typebot.io/mi-bot, el slug es \"mi-bot\".",
            step3: "En el campo \"URL del Typebot\" arriba, pega la URL base de tu instancia (sin barra al final). En el campo \"Slug\", pega el identificador del bot.",
            step4: "Configura la expiración de sesión (en minutos). Después de ese tiempo sin interacción, se iniciará una nueva conversación. Valor 0 = nunca expira.",
            step5: "Opcionalmente, define palabras clave para finalizar (ej: \"salir\") o reiniciar (ej: \"reiniciar\") la conversación con el bot.",
            variablesTitle: "Variables disponibles en Typebot:",
            varNumber: "Número del contacto en WhatsApp",
            varPushName: "Nombre del contacto en WhatsApp",
            varRemoteJid: "ID completo del contacto (JID)",
            jsonTitle: "Comandos avanzados (JSON):",
            jsonDesc: "En Typebot, envía un mensaje comenzando con # para ejecutar acciones en ChatIA:",
            jsonStop: "Detiene el bot y transfiere a un agente",
            jsonQueue: "Transfiere a la cola ID 1",
            jsonUser: "Transfiere a cola 1, agente 5",
            tip: "Consejo: Typebot soporta textos, imágenes, audios, videos y botones de selección. Todos se envían automáticamente por WhatsApp.",
          },
        },
        menuModal: {
          titleAdd: "Agregar menú al flujo",
          titleEdit: "Editar menú",
          buttonAdd: "Añadir",
          buttonSave: "Guardar",
          fields: {
            explanationMessage: "Mensaje de explicación del menú",
            addOption: "Agregar Opción",
            typeOption: "Escriba {{number}}",
            optionPlaceholder: "Escriba opción"
          },
          invalidOption: {
            title: "Opción inválida",
            messageLabel: "Mensaje para opción inválida",
            placeholder: "Ej: Opción inválida. Por favor, elija una de las opciones a continuación:",
            helperText: "Si se completa, cuando el cliente envíe algo fuera de las opciones, este mensaje será enviado y el menú se mostrará nuevamente."
          },
          timeout: {
            title: "Timeout (sin respuesta)",
            label: "Tiempo en segundos (0 = desactivado)",
            helperText: "Si el cliente no responde en {{seconds}}s, el flujo sigue por el camino de timeout (salida naranja)"
          },
          aiTimeout: {
            title: "Salida IA (tiempo para que la IA asuma)",
            label: "Tiempo en segundos (0 = desactivado)",
            helperText: "Si el cliente no responde en {{seconds}}s, la IA asume la atención (salida morada)"
          }
        },
        singleBlockModal: {
          titleAdd: "Agregar contenido al flujo",
          titleEdit: "Editar contenido",
          buttonAdd: "Añadir",
          buttonSave: "Guardar",
          elements: {
            text: "Texto",
            interval: "Intervalo",
            image: "Imagen",
            audio: "Audio",
            video: "Video",
            document: "Documento"
          },
          fields: {
            message: "Mensaje",
            timeInSeconds: "Tiempo en segundos",
            sendAsRecordedAudio: "Enviar como audio grabado en el momento",
            noFileSelected: "Ningún archivo seleccionado"
          },
          buttons: {
            sendImage: "Enviar imagen",
            sendAudio: "Enviar audio",
            sendVideo: "Enviar video",
            sendDocument: "Enviar Documento"
          },
          validation: {
            emptyMessageFields: "¡Campos de mensaje vacíos!",
            intervalValidation: "¡El intervalo no puede ser 0 o mayor que 120!",
            fileTooLarge2MB: "¡Archivo muy grande! Máximo 2MB",
            fileTooLarge5MB: "¡Archivo muy grande! Máximo 5MB",
            fileTooLarge20MB: "¡Archivo muy grande! Máximo 20MB",
            fileTooLarge15MB: "¡Archivo muy grande! Máximo 15MB",
            deleteEmptyCards: "Elimina las tarjetas vacías o envía los archivos pendientes.",
            browserNotSupported: "su navegador no soporta HTML5",
            onlyMp4Videos: "¡ATENCIÓN! ¡Solo videos en MP4!",
            uploadError: "Error al procesar el archivo"
          },
          messages: {
            contentAddedSuccess: "¡Contenido agregado con éxito!",
            uploadingFiles: "Subiendo archivos y creando contenido...",
            variables: "Variables"
          },
          timeout: {
            title: "Timeout (sin respuesta)",
            label: "Tiempo en segundos (0 = desactivado)",
            helperText: "Si el cliente no responde en {{seconds}}s, el flujo sigue por la ruta de timeout (salida amarilla)"
          },
          aiTimeout: {
            title: "Salida IA (tiempo para que la IA asuma)",
            label: "Tiempo en segundos (0 = desactivado)",
            helperText: "Si el cliente no responde en {{seconds}}s, la IA asume la atención (salida morada)"
          },
          audioRecorder: {
            or: "o",
            recordAudio: "Grabar audio",
            recording: "Grabando",
            paused: "Pausado",
            recordingCompleted: "Grabación finalizada - {{time}}",
            discard: "Descartar",
            useThisAudio: "Usar este audio",
            cancel: "Cancelar",
            pause: "Pausar",
            resume: "Continuar",
            finish: "Finalizar",
            pausedHint: "Escucha la vista previa, continúa o finaliza la grabación",
            recordingHint: "Pausa o finaliza la grabación",
            microphoneError: "No fue posible acceder al micrófono. Verifica los permisos del navegador."
          }
        },
        randomizerModal: {
          titleAdd: "Agregar un aleatorizador al flujo",
          titleEdit: "Editar aleatorizador",
          title: "Distribución de salidas",
          sliderLabel: "Porcentaje del aleatorizador",
          outputsTitle: "Cómo funciona",
          outputsHint: "El primer porcentaje sigue por la primera salida; el restante sigue por la segunda salida.",
          buttonAdd: "Añadir",
          buttonEdit: "Editar"
        },
        ticketModal: {
          titleAdd: "Agregar una cola al flujo",
          titleEdit: "Editar cola",
          buttonAdd: "Agregar",
          buttonEdit: "Editar",
          fields: {
            selectConnection: "Seleccione una Conexión"
          },
          validation: {
            addQueue: "Agrega una cola"
          }
        },
        openaiModal: {
          titleAdd: "Agregar OpenAI/Gemini al flujo",
          titleEdit: "Editar OpenAI/Gemini del flujo",
          buttonAdd: "Agregar",
          buttonSave: "Guardar",
          models: {
            "gpt-4.1": "GPT 4.1",
            "gpt-4.1-mini": "GPT 4.1 Mini",
            "gpt-4.1-nano": "GPT 4.1 Nano",
            "gpt-4o": "GPT 4o",
            "gpt-4o-mini": "GPT 4o Mini",
            "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legado)",
            "gemini-2.5-pro": "Gemini 2.5 Pro",
            "gemini-2.5-flash": "Gemini 2.5 Flash",
            "gemini-2.0-flash": "Gemini 2.0 Flash",
            "gemini-2.0-pro": "Gemini 2.0 Pro",
          },
          voices: {
            text: "Texto",
            francisca: "Francisca",
            antonio: "Antonio",
            brenda: "Brenda",
            donato: "Donato",
            elza: "Elza",
            fabio: "Fabio",
            giovanna: "Giovanna",
            humberto: "Humberto",
            julio: "Julio",
            leila: "Leila",
            leticia: "Leticia",
            manuela: "Manuela",
            nicolau: "Nicolau",
            valerio: "Valerio",
            yara: "Yara"
          },
          validation: {
            tooShort: "¡Muy corto!",
            tooLong: "¡Muy largo!",
            required: "Obligatorio",
            promptRequired: "Describe el entrenamiento para Inteligencia Artificial",
            invalidModel: "Modelo inválido",
            minTokens: "Mínimo 10 tokens",
            maxTokens: "Máximo 4096 tokens",
            tokensRequired: "Informa el número máximo de tokens",
            temperatureRequired: "Informa la temperatura",
            temperatureMin: "Mínimo 0",
            temperatureMax: "Máximo 1",
            apiKeyRequired: "Informa la API Key",
            messagesMin: "Mínimo 1 mensaje",
            messagesMax: "Máximo 50 mensajes",
            messagesRequired: "Informa el número máximo de mensajes",
            voiceRequired: "Informa el modo para Voz"
          },
          instructions: {
            title: "Cómo configurar OpenAI (paso a paso)",
            step1: "Accede a platform.openai.com y crea una cuenta. En el menú lateral, ve a \"API Keys\" y haz clic en \"Create new secret key\". Copia la clave generada.",
            step2: "Pega la clave en el campo \"API Key\" arriba. Esta clave es secreta — no la compartas con nadie.",
            step3: "En el campo \"Prompt\", escribe las instrucciones de comportamiento de la IA. Ejemplo: \"Eres un asistente virtual de la empresa X. Responde de forma educada y objetiva sobre nuestros productos y servicios.\"",
            step4: "Elige el modelo: GPT-4o Mini es la mejor relación calidad-precio para atención al cliente. GPT-4.1 es más inteligente pero más caro. GPT-3.5 Turbo es el más barato.",
            step5: "La temperatura controla la creatividad (0 = respuestas exactas, 1 = respuestas creativas). Para atención al cliente, usa entre 0.3 y 0.7. Max Tokens limita el tamaño de la respuesta.",
            promptTipTitle: "Consejos para un buen prompt:",
            promptTip: "Sé específico sobre el rol de la IA, el tono de voz, los productos/servicios de la empresa y lo que NO debe hacer. Cuanto más detallado el prompt, mejores las respuestas.",
            tip: "Consejo: El campo \"Máx. Mensajes\" define cuántos mensajes de contexto recuerda la IA. Valores mayores = respuestas más contextuales pero cuestan más tokens.",
          },
        },
        geminiModal: {
          instructions: {
            title: "Cómo configurar Gemini IA (paso a paso)",
            step1: "Accede a aistudio.google.com e inicia sesión con tu cuenta de Google. Haz clic en \"Get API Key\" y luego \"Create API key\". Copia la clave generada.",
            step2: "Pega la clave en el campo \"API Key (Google AI)\" arriba. Esta clave es secreta — no la compartas con nadie.",
            step3: "En el campo \"Prompt\", escribe las instrucciones de comportamiento de la IA. Ejemplo: \"Eres un asistente virtual de la empresa X. Responde de forma educada y objetiva.\"",
            step4: "Elige el modelo: Gemini 2.5 Flash es la mejor relación calidad-precio. Gemini 2.5 Pro es más inteligente pero más lento. Gemini 2.0 Flash es el más rápido.",
            step5: "La temperatura controla la creatividad (0 = respuestas exactas, 1 = respuestas creativas). Para atención al cliente, usa entre 0.3 y 0.7.",
            promptTipTitle: "Consejos para un buen prompt:",
            promptTip: "Sé específico sobre el rol de la IA, el tono de voz, los productos/servicios y lo que NO debe hacer. Cuanto más detallado, mejores las respuestas.",
            tip: "Consejo: Gemini de Google tiene un plan gratuito generoso. Ideal para empezar a probar sin costos.",
          },
        },
        questionModal: {
          titleAdd: "Agregar Pregunta al flujo",
          titleEdit: "Editar Pregunta del flujo",
          titleCreate: "Crear Pregunta en el flujo",
          buttonAdd: "Añadir",
          buttonSave: "Guardar",
          fields: {
            message: "Mensaje",
            saveAnswer: "Guardar respuesta"
          },
          timeout: {
            title: "Timeout (sin respuesta)",
            label: "Tiempo en segundos (0 = desactivado)",
            helperText: "Si el cliente no responde en {{seconds}}s, el flujo sigue por la salida de timeout (salida amarilla)"
          },
          aiTimeout: {
            title: "Salida IA (tiempo para que la IA asuma)",
            label: "Tiempo en segundos (0 = desactivado)",
            helperText: "Si el cliente no responde en {{seconds}}s, la IA asume la atención (salida morada)"
          }
        }
      },
      moments: {
        title: "Panel en tiempo real",
        subtitle: "Atenciones en vivo agrupadas por agente",
        pending: "Pendientes",
        attendances: "Atenciones: ",
        noQueue: "Sin cola",
        accessTicket: "Acceder al ticket",
        refresh: "Actualizar",
        empty: "No hay atenciones activas en este momento.",
        noTickets: "Sin atenciones activas",
        ticketSingular: "atención",
        ticketsPlural: "atenciones",
        unread: "no leídas",
        kpis: {
          online: "Agentes online",
          active: "En atención",
          pending: "En espera",
          top: "Mejor agente",
        },
      },
      flowBuilderNodes: {
        message: "Mensaje",
        condition: "Condición",
        image: "Imagen"
      },
      subscription: {
        title: "Suscripción",
        form: {
          licenseLabel: "Período de Licencia",
          licenseExpiresIn: "Su licencia expira en {{days}} días!",
          licenseExpiresToday: "Su licencia expira hoy!",
          billingEmailLabel: "Email de facturación",
          subscribeButton: "¡Suscribirse Ahora!"
        },
        checkout: {
          form: {
            fullName: "Nombre completo*",
            fullNameRequired: "El nombre completo es obligatorio",
            lastName: "Apellido*",
            lastNameRequired: "El apellido es obligatorio",
            address: "Dirección*",
            addressRequired: "La dirección es obligatoria",
            city: "Ciudad*",
            cityRequired: "La ciudad es obligatoria",
            state: "Estado*",
            stateRequired: "El estado es obligatorio",
            document: "RUC/DNI*",
            documentRequired: "RUC/DNI es obligatorio",
            documentInvalid: "Formato de RUC/DNI inválido",
            country: "País*",
            countryRequired: "El país es obligatorio",
            useAddressForPayment: "Usar esta dirección para detalles de pago",
            nameOnCard: "Nombre en la tarjeta*",
            nameOnCardRequired: "El nombre en la tarjeta es obligatorio",
            cardNumber: "Número de tarjeta*",
            cardNumberRequired: "El número de tarjeta es obligatorio",
            cardNumberInvalid: "El número de tarjeta no es válido (ej. 4111111111111)",
            expiryDate: "Fecha de expiración*",
            expiryDateRequired: "La fecha de expiración es obligatoria",
            expiryDateInvalid: "La fecha de expiración no es válida",
            cvv: "CVV*",
            cvvRequired: "CVV es obligatorio",
            cvvInvalid: "CVV es inválido (ej. 357)"
          }
        }
      },
      ticketsResponsive: {
        actions: {
          selectTicket: "Seleccionar Ticket",
          transferTicket: "Transferir Ticket",
          spyConversation: "Espiar Conversación"
        },
        tabs: {
          ticket: "Ticket",
          assistance: "Atenciones"
        },
        search: {
          searchInMessagesTooltip: "Marcar para buscar también en contenidos de mensajes (más lento)"
        },
        filter: {
          all: "Todos",
          unreplied: "Sin responder",
          title: "Filtros",
          queues: "Colas",
          tags: "Etiquetas",
          connections: "Conexiones",
          status: "Estado",
          users: "Usuarios",
          showTags: "Mostrar etiquetas",
          hideTags: "Ocultar etiquetas"
        },
        sort: {
          ascending: "Ascendente",
          descending: "Descendente"
        },
        dialog: {
          spyingConversation: "Espiando conversación",
          loadingMessages: "Cargando mensajes..."
        },
        status: {
          noQueue: "SIN COLA"
        }
      },
      messagesResponsive: {
        types: {
          location: "Ubicación",
          contact: "Contacto"
        },
        actions: {
          download: "Descargar",
          dropFileHere: "Suelta el archivo aquí"
        },
        status: {
          forwarded: "Reenviada",
          deletedByContact: "🚫 Este mensaje fue eliminado por el contacto",
          deletedMessage: "🚫 _Mensaje eliminado_",
          deletedByMe: "🚫 Este mensaje fue eliminado",
          edited: "Editada"
        },
        reactions: {
          youReacted: "Reaccionaste...",
          contactReacted: " reaccionó... "
        },
        timestamp: {
          today: "HOY"
        },
        placeholder: {
          sayHello: "¡Saluda a tu nuevo contacto!"
        },
        ads: {
          adClick: "Clic de Anuncio",
          defaultUserMessage: "¡Hola! Tengo interés y quisiera más información, por favor."
        },
        warnings: {
          facebookPolicy: "Tienes 24 horas para responder después de recibir un mensaje, según las políticas de Facebook."
        },
        translation: {
          translatedFrom: "Traducido de",
          showOriginal: "Ver original",
          showTranslation: "Ver traducción",
          autoTranslated: "Mensaje traducido automáticamente enviado",
        },
        transcription: {
          transcribe: "Transcribir audio",
          transcribing: "Transcribiendo...",
          showOriginal: "Ver original",
          showTranslation: "Ver traducción",
          language: "Idioma",
        }
      },
      messageInputResponsive: {
        type: {
          document: "Documento",
          buttons: "Botones"
        },
        tooltip: {
          toggleSignature: "Habilitar/Deshabilitar Firma",
          toggleComments: "Habilitar/Deshabilitar Comentarios"
        },
        privateMessage: {
          suffix: "Mensaje Privado"
        }
      },
      tagsResponsive: {
        validation: {
          tooShort: "¡Etiqueta muy corta!"
        },
        placeholder: "Etiquetas"
      },
      showTicketOpenModal: {
        buttons: {
          close: "Cerrar"
        }
      },
      reactions: {
        successMessage: "Reacción enviada con éxito"
      },
      vcardPreview: {
        chatButton: "Chatear"
      },
      locationPreview: {
        viewButton: "Ver"
      },
      contactNotes: {
        addedSuccess: "¡Nota agregada con éxito!",
        deletedSuccess: "¡Nota eliminada con éxito!",
        deleteTitle: "Eliminar Registro",
        deleteConfirmation: "¿Realmente desea eliminar este registro?",
        cancelButton: "Cancelar",
        saveButton: "Guardar"
      },
      validationResponsive: {
        ratingRequired: "Calificación requerida"
      }
    }
  }
};

export { messages };
